(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea917"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea917"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
class $345c9606acf49e28$export$4fae95256245c8c0 {
    on(event, listener) {
        if (typeof this.events[event] !== "object") this.events[event] = [];
        this.events[event].push(listener);
        return ()=>this.off(event, listener);
    }
    off(event, listener) {
        if (typeof this.events[event] !== "object") return;
        this.events[event] = this.events[event].filter((eventListener)=>eventListener !== listener);
    }
    offAll() {
        Object.keys(this.events).forEach((event)=>this.events[event] = []);
    }
    emit(event, ...args) {
        if (typeof this.events[event] === "object") [
            ...this.events[event]
        ].forEach((listener)=>listener.apply(this, args));
        [
            ...this.events["*"]
        ].forEach((listener)=>listener.apply(this, [
                event,
                ...args
            ]));
    }
    once(event, listener) {
        const remove = this.on(event, (...args)=>{
            remove();
            listener.apply(this, args);
        });
        return remove;
    }
    constructor(){
        this.events = {
            "*": []
        };
    }
}


class $5c07417a90a15ad5$export$2e2bcd8739ae039 extends (0, $345c9606acf49e28$export$4fae95256245c8c0) {
    /**
     * Component state change logic
     *
     * @param newState state value to change
     * @param preventRender If true, no rendering is done after the state is changed.
     * @param callback If set, called back if state has changed.
     */ setState(newState, preventRender, callback) {
        if (!this.checkNeedUpdate(newState)) return;
        if (this.state) this.state = {
            ...this.state,
            ...newState
        };
        else this.state = {
            ...newState
        };
        if (callback) {
            callback();
            return;
        }
        if (preventRender) return;
        this.render();
    }
    /**
     * Component state validation, basic... can use more advanced like fast-deep-equal package
     *
     * @param newState state value to validate
     */ checkNeedUpdate(newState) {
        const prevState = JSON.stringify({
            ...this.state
        });
        const currentState = JSON.stringify({
            ...this.state,
            ...newState
        });
        return prevState !== currentState;
    }
    constructor({ $target: $target, initialState: initialState }){
        super();
        this.$target = $target;
        this.state = initialState;
        this.init();
        this.render();
    }
}



function $d1947f3ca833a885$export$89a7e74069fbb7af(params = {}) {
    let queryString = "";
    Object.keys(params).forEach((key)=>{
        if (queryString.length !== 0) queryString += "&";
        queryString += key + "=" + params[key].toString();
    });
    return queryString;
}
function $d1947f3ca833a885$export$b89605802fcf91d2(polylineString, precision = 5) {
    const coordinates = [];
    const factor = Math.pow(10, precision);
    let index, lat, lng, byte, shift, result, latitude_change, longitude_change;
    index = 0;
    lat = 0;
    lng = 0;
    while(index < polylineString.length){
        byte = null;
        shift = 0;
        result = 0;
        do {
            byte = polylineString.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        }while (byte >= 0x20);
        latitude_change = result & 1 ? ~(result >> 1) : result >> 1;
        shift = result = 0;
        do {
            byte = polylineString.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        }while (byte >= 0x20);
        longitude_change = result & 1 ? ~(result >> 1) : result >> 1;
        lat += latitude_change;
        lng += longitude_change;
        coordinates.push([
            lat / factor,
            lng / factor
        ]);
    }
    return coordinates;
}
function $d1947f3ca833a885$export$61fc7d43ac8f84b0(callback, timeout) {
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            callback(...args);
        }, timeout);
    };
}
function $d1947f3ca833a885$export$37827d046293d309(text) {
    const canvas = document.getElementById("canvasMarkerWoosmap") || document.createElement("canvas");
    canvas.id = "canvasMarkerWoosmap";
    const context = canvas.getContext("2d", {
        willReadFrequently: true
    });
    context.font = "bold 15px sans-serif";
    return context.measureText(text).width;
}
function $d1947f3ca833a885$export$a6cdc56e425d0d0a(input) {
    return typeof input === "object" && input !== null && !Array.isArray(input);
}
function $d1947f3ca833a885$export$4950aa0f605343fb(target, source) {
    if (!$d1947f3ca833a885$export$a6cdc56e425d0d0a(source) || !$d1947f3ca833a885$export$a6cdc56e425d0d0a(target)) return target;
    for(const key in source){
        const targetProp = target[key];
        const sourceProp = source[key];
        if ($d1947f3ca833a885$export$a6cdc56e425d0d0a(sourceProp) && $d1947f3ca833a885$export$a6cdc56e425d0d0a(targetProp)) $d1947f3ca833a885$export$4950aa0f605343fb(targetProp, sourceProp);
        else if (!(key in target)) target[key] = source[key];
    }
    return target;
}
function $d1947f3ca833a885$export$77ad94ebf1c2b9ed(str, keyValues) {
    let result = str;
    Object.keys(keyValues).forEach((key)=>{
        result = result.replace(new RegExp("\\{\\s*" + key + "\\s*\\}", "g"), keyValues[key]);
    });
    return result;
}


/**
 * Previously loading/loaded scripts that have been requested by `loadScript()`.
 */ let $3408065cc4bfa60b$var$cachedScripts = {};
function $3408065cc4bfa60b$export$2cb99e4be0dc4646(options) {
    const { url: url, params: params, override: override } = options;
    if (!url || url.length === 0) throw new Error("Invalid url.");
    if (typeof params !== "undefined" && typeof params !== "object") throw new Error("Expected params to be an object.");
    const src = `${url}?${(0, $d1947f3ca833a885$export$89a7e74069fbb7af)(params)}`;
    const existing = $3408065cc4bfa60b$var$cachedScripts[src];
    if (existing) {
        if (override) {
            const script = $3408065cc4bfa60b$var$getScriptElement(src);
            if (script) {
                delete $3408065cc4bfa60b$var$cachedScripts[src];
                script.remove();
            }
        } else return existing;
    }
    const promise = new Promise((resolve, reject)=>{
        if ($3408065cc4bfa60b$var$findScript(src)) resolve();
        const script = $3408065cc4bfa60b$export$28503efd90ff36be(url, params);
        const onScriptLoad = ()=>{
            resolve();
        };
        const onScriptError = ()=>{
            cleanup();
            delete $3408065cc4bfa60b$var$cachedScripts[src];
            script.remove();
            const defaultError = new Error(`The script "${src}" failed to load.`);
            reject(defaultError);
        };
        script.addEventListener("load", onScriptLoad);
        script.addEventListener("error", onScriptError);
        document.head.insertBefore(script, document.head.firstElementChild);
        function cleanup() {
            script.removeEventListener("load", onScriptLoad);
            script.removeEventListener("error", onScriptError);
        }
    });
    $3408065cc4bfa60b$var$cachedScripts[src] = promise;
    return promise;
}
/**
 * Find script src in the DOM
 * @param {string} src - used to set the script url and attributes.
 * @return {boolean | null} returns `true` if script exist otherwise `null`.
 */ function $3408065cc4bfa60b$var$findScript(src) {
    const currentScript = document.querySelector(`script[src="${src}"]`);
    if (currentScript === null) return null;
    return true;
}
/**
 * Get script by src in the DOM
 * @param {string} src - used to set the script url and attributes.
 * @return {HTMLScriptElement | null} returns existing `HTMLScriptElement` if script exist otherwise `null`.
 */ function $3408065cc4bfa60b$var$getScriptElement(src) {
    const currentScript = document.querySelector(`script[src="${src}"]`);
    if (currentScript === null) return null;
    return currentScript;
}
function $3408065cc4bfa60b$export$28503efd90ff36be(url, params = {}) {
    const newScript = document.createElement("script");
    newScript.src = `${url}?${(0, $d1947f3ca833a885$export$89a7e74069fbb7af)(params)}`;
    newScript.async = true;
    return newScript;
}
function $3408065cc4bfa60b$export$41a88579f6bd1282() {
    $3408065cc4bfa60b$var$cachedScripts = {};
}


class $c2ef843a781cd26d$export$2e2bcd8739ae039 {
    getIconType(options) {
        if (options.selected) return "selectedIcon";
        else return "icon";
    }
    getStyledIcon(options = {}) {
        let matchedIcon;
        const iconType = this.getIconType(options);
        const defaultIcon = this.style.default[iconType];
        if (defaultIcon !== undefined) matchedIcon = {
            icon: defaultIcon
        };
        else matchedIcon = {
            icon: this.style.default.icon
        };
        if (options.types !== undefined && this.style.rules) {
            for (const rule of this.style.rules)for (const type of options.types){
                const ruleIcon = rule[iconType];
                if (rule.type === type) {
                    if (ruleIcon) return {
                        icon: ruleIcon,
                        type: type
                    };
                }
            }
        }
        return matchedIcon;
    }
    constructor(style){
        this.style = style;
    }
}



/**
 * Language: English.
 */ var $11a4ca60042eefa8$export$2e2bcd8739ae039 = {
    time: {
        openingHoursTitle: "Opening hours",
        at: "at",
        opensToday: "Opens today",
        opens: "Opens",
        open24_7: "Open 24/7",
        closed: "Closed",
        openUntil: "Open until",
        daily: "Daily opened",
        month: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        monthAbbr: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        dayOfWeek: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        dayOfWeekAbbr: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ]
    },
    search: {
        placeholder: "Search a location...",
        submitLabel: "Search",
        clearLabel: "Clear Search",
        yourLocation: "Your location"
    },
    filtering: {
        servicesTitle: "Services",
        services: {
            WF: "Wireless Hotspot",
            DT: "Drive-Thru",
            DR: "Digital Rewards",
            hrs24: "Open 24 hours per day",
            WA: "Oven-warmed Food",
            XO: "Mobile Order and Pay",
            NB: "Nitro Cold Brew",
            CL: "Starbucks Reserve-Clover Brewed"
        }
    },
    stores: {
        cta: {
            call: "Call",
            directions: "Directions",
            website: "Website"
        },
        messages: {
            initialHeader: "Start by searching a locality to display nearby stores",
            emptyHeader: "No store returned",
            initialBody: "or click on the Map to select a store",
            emptyBody: "Please Search a locality elsewhere or unselect your filters"
        }
    },
    directions: {
        avoidOptions: {
            highways: "Highways",
            tolls: "Tolls",
            ferries: "Ferries"
        },
        unitOptions: {
            METRIC: "km",
            IMPERIAL: "miles"
        },
        options: "Route options",
        avoid: "Avoid",
        units: "Distance units",
        messages: {
            initialBody: "Search an origin and destination to see available routes and time travel.",
            error: "Sorry, we could not calculate driving directions",
            from: "from",
            to: "to",
            forTravelMode: "for the travel mode",
            via: "through",
            details: "Details",
            withoutTraffic: "without traffic",
            openGoogleMaps: "open in google maps"
        }
    },
    errors: {
        loadingLibrary: "failed to load the {library} script",
        geolocationFailed: "User Geolocation failed",
        apiErrors: {
            "401": "Unauthorized",
            "403": "Forbidden",
            "429": "Too many requests",
            "500": "Internal server error",
            other: "An unexpected server error occurred"
        }
    }
};


/**
 * Language: Français.
 */ var $61383195196e36ea$export$2e2bcd8739ae039 = {
    time: {
        openingHoursTitle: "Horaires d'ouverture",
        at: "\xe0",
        opensToday: "Ouvre aujourd'hui",
        opens: "Ouvre",
        open24_7: "Ouvert 24/7",
        closed: "Ferm\xe9",
        openUntil: "Ouvert jusqu'\xe0",
        daily: "Ouvert tous les jours",
        month: [
            "Janvier",
            "F\xe9vrier",
            "Mars",
            "Avril",
            "Mai",
            "Juin",
            "Juillet",
            "Ao\xfbt",
            "Septembre",
            "Octobre",
            "Novembre",
            "D\xe9cembre"
        ],
        monthAbbr: [
            "Jan",
            "F\xe9v",
            "Mars",
            "Avr",
            "Mai",
            "Juin",
            "Juil",
            "Ao\xfbt",
            "Sept",
            "Oct",
            "Nov",
            "D\xe9c"
        ],
        dayOfWeek: [
            "Dimanche",
            "Lundi",
            "Mardi",
            "Mercredi",
            "Jeudi",
            "Vendredi",
            "Samedi"
        ],
        dayOfWeekAbbr: [
            "Dim",
            "Lun",
            "Mar",
            "Mer",
            "Jeu",
            "Ven",
            "Sam"
        ]
    },
    search: {
        placeholder: "Rechercher un lieu...",
        submitLabel: "Rechercher",
        clearLabel: "Effacer la recherche",
        yourLocation: "Votre position"
    },
    filtering: {
        servicesTitle: "Services",
        services: {
            WF: "Hotspot Wi-Fi",
            DT: "Drive",
            DR: "Carte de Fid\xe9lit\xe9",
            hrs24: "Ouvert 24h/24",
            WA: "Plats chauds",
            XO: "Mobile Order and Pay",
            NB: "Nitro Cold Brew",
            CL: "Starbucks Reserve-Clover Brewed"
        }
    },
    stores: {
        cta: {
            call: "Appeler",
            directions: "Itin\xe9raire",
            website: "Site Web"
        },
        messages: {
            initialHeader: "Chercher une localit\xe9 pour afficher les magasins \xe0 proximit\xe9",
            emptyHeader: "Aucun magasin retourn\xe9",
            initialBody: "ou s\xe9lectionner un magasin via la carte",
            emptyBody: "Rechercher ailleurs or d\xe9sactiver vos filtres"
        }
    },
    directions: {
        avoidOptions: {
            highways: "Autoroutes",
            tolls: "P\xe9ages",
            ferries: "Transbordeurs"
        },
        unitOptions: {
            METRIC: "km",
            IMPERIAL: "milles"
        },
        options: "Options d'itin\xe9raire",
        avoid: "\xc9viter",
        units: "Unit\xe9s de distance",
        messages: {
            initialBody: "Renseigner une origine et une destination pour voir les itin\xe9raires disponible et le temps de trajet.",
            error: "D\xe9sol\xe9, impossible de calculer l'itin\xe9raire",
            from: "de",
            to: "\xe0",
            forTravelMode: "pour le mode de transport",
            via: "via",
            details: "Details",
            withoutTraffic: "sans circulation",
            openGoogleMaps: "ouvrir dans Google Maps"
        }
    },
    errors: {
        loadingLibrary: "Impossible de charger le script {library}",
        geolocationFailed: "Impossible de g\xe9olocaliser l'utilisateur",
        apiErrors: {
            "401": "Unauthorized",
            "403": "Forbidden",
            "429": "Too many requests",
            "500": "Internal server error",
            other: "An unexpected server error occurred"
        }
    }
};



const $6594c97b430a236e$var$LOCALE_EN = "EN";
const $6594c97b430a236e$var$DEFAULT_LOCALE = $6594c97b430a236e$var$LOCALE_EN;
let $6594c97b430a236e$var$USER_LOCALE;
const $6594c97b430a236e$var$localeStorage = {};
const $6594c97b430a236e$export$9a2147b3808d4c6b = function() {
    return $6594c97b430a236e$var$DEFAULT_LOCALE;
}();
function $6594c97b430a236e$var$registerLocale(locale, localeObj) {
    locale = locale.toUpperCase();
    $6594c97b430a236e$var$localeStorage[locale] = localeObj;
}
function $6594c97b430a236e$export$ddc371781a6af754(lang, localeObj) {
    if (lang) {
        const localeObj = $6594c97b430a236e$var$localeStorage[lang.toUpperCase()] || {};
        if (lang === $6594c97b430a236e$var$LOCALE_EN) return {
            ...localeObj
        };
        else return (0, $d1947f3ca833a885$export$4950aa0f605343fb)({
            ...localeObj
        }, {
            ...$6594c97b430a236e$var$localeStorage[$6594c97b430a236e$var$DEFAULT_LOCALE]
        });
    } else return (0, $d1947f3ca833a885$export$4950aa0f605343fb)({
        ...localeObj
    }, {
        ...$6594c97b430a236e$var$localeStorage[$6594c97b430a236e$var$DEFAULT_LOCALE]
    });
}
function $6594c97b430a236e$export$e6103b0362967aab(lang) {
    if (lang) {
        $6594c97b430a236e$var$USER_LOCALE = lang;
        const userLocale = $6594c97b430a236e$export$ddc371781a6af754(lang);
        $6594c97b430a236e$var$registerLocale(lang, userLocale);
    }
}
function $6594c97b430a236e$export$180605366c04f0cd(lang) {
    if (lang) return $6594c97b430a236e$var$localeStorage[lang];
    else if ($6594c97b430a236e$var$USER_LOCALE) return $6594c97b430a236e$var$localeStorage[$6594c97b430a236e$var$USER_LOCALE];
    else return $6594c97b430a236e$var$localeStorage[$6594c97b430a236e$var$DEFAULT_LOCALE];
}
function $6594c97b430a236e$export$3814be8b8b1016be() {
    return $6594c97b430a236e$var$USER_LOCALE || $6594c97b430a236e$var$DEFAULT_LOCALE;
}
function $6594c97b430a236e$export$665560c9ff312dd4() {
    return (document.documentElement.lang || navigator.language || navigator.browserLanguage).toUpperCase();
}
function $6594c97b430a236e$export$236350842f3cd9bc(localeObj, key) {
    if (localeObj[key] !== undefined && typeof localeObj[key] === "string") return localeObj[key];
    else return key;
}
$6594c97b430a236e$var$registerLocale($6594c97b430a236e$var$LOCALE_EN, (0, $11a4ca60042eefa8$export$2e2bcd8739ae039));
$6594c97b430a236e$var$registerLocale("FR", (0, $61383195196e36ea$export$2e2bcd8739ae039));


const $e990629b6dc59f12$var$woosmapPublicKey = "woos-48c80350-88aa-333e-835a-07f4b658a9a4";
const $e990629b6dc59f12$var$mobileBreakPoint = 768;
const $e990629b6dc59f12$var$userLocationIconOptions = {
    url: "https://images.woosmap.com/user-position.png",
    scaledSize: {
        height: 32,
        width: 32
    }
};
const $e990629b6dc59f12$var$mapPaddings = {
    mobile: {
        left: 50,
        right: 50,
        top: 50,
        bottom: 550
    },
    full: {
        left: 450,
        right: 50,
        top: 50,
        bottom: 50
    }
};
const $e990629b6dc59f12$var$storesStyle = {
    breakPoint: 11,
    rules: [],
    default: {
        color: "#008a2f",
        size: 8,
        minSize: 1,
        icon: {
            url: "https://images.woosmap.com/starbucks-marker.svg",
            scaledSize: {
                height: 40,
                width: 34
            }
        },
        selectedIcon: {
            url: "https://images.woosmap.com/starbucks-marker-selected.svg",
            scaledSize: {
                height: 50,
                width: 43
            }
        }
    }
};
const $e990629b6dc59f12$var$mapOptions = {
    center: {
        lat: 46.2,
        lng: 3.2
    },
    zoom: 6,
    styles: [
        {
            featureType: "point_of_interest",
            elementType: "all",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "point_of_interest.business.shop",
            elementType: "all",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "point_of_interest.business.food_and_drinks",
            elementType: "all",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        }
    ],
    gestureHandling: "greedy"
};
var $e990629b6dc59f12$export$2e2bcd8739ae039 = {
    mapOptions: $e990629b6dc59f12$var$mapOptions,
    storesStyle: $e990629b6dc59f12$var$storesStyle,
    mapPaddings: $e990629b6dc59f12$var$mapPaddings,
    mobileBreakPoint: $e990629b6dc59f12$var$mobileBreakPoint,
    woosmapPublicKey: $e990629b6dc59f12$var$woosmapPublicKey,
    userLocationIconOptions: $e990629b6dc59f12$var$userLocationIconOptions
};


const $910b94fe3f3e6ae5$var$directionsOptions = {
    travelMode: "DRIVING",
    unitSystem: "METRIC",
    provideRouteAlternatives: true,
    avoid: []
};
const $910b94fe3f3e6ae5$var$distanceMatrixOptions = {
    travelMode: "DRIVING",
    unitSystem: "METRIC"
};
const $910b94fe3f3e6ae5$var$avoidOptions = [
    {
        paramKey: "highways"
    },
    {
        paramKey: "tolls"
    },
    {
        paramKey: "ferries"
    }
];
const $910b94fe3f3e6ae5$var$unitOptions = [
    {
        paramKey: "METRIC"
    },
    {
        paramKey: "IMPERIAL"
    }
];
const $910b94fe3f3e6ae5$var$travelModes = [
    {
        modeKey: "DRIVING",
        defaultIcon: "https://images.woosmap.com/directions/drive.png",
        selectedIcon: "https://images.woosmap.com/directions/drive_selected.png",
        darkIcon: "https://images.woosmap.com/directions/drive_black.png"
    },
    {
        modeKey: "WALKING",
        defaultIcon: "https://images.woosmap.com/directions/walk.png",
        selectedIcon: "https://images.woosmap.com/directions/walk_selected.png",
        darkIcon: "https://images.woosmap.com/directions/walk_black.png"
    },
    {
        modeKey: "CYCLING",
        defaultIcon: "https://images.woosmap.com/directions/bicycle.png",
        selectedIcon: "https://images.woosmap.com/directions/bicycle_selected.png",
        darkIcon: "https://images.woosmap.com/directions/bicycle_black.png"
    }
];
const $910b94fe3f3e6ae5$var$iconsDirections = {
    start: {
        url: "https://images.woosmap.com/directions/directions_start.png",
        scaledSize: {
            height: 14,
            width: 14
        }
    },
    end: {
        url: "https://images.woosmap.com/directions/directions_destination.png",
        scaledSize: {
            height: 16,
            width: 16
        }
    }
};
const $910b94fe3f3e6ae5$var$stepsIcon = [
    {
        index: 1,
        key: "Start",
        icon: "https://images.woosmap.com/directions/straight_black.png"
    },
    {
        index: 2,
        key: "StartRight",
        icon: "https://images.woosmap.com/directions/turn_slight_left_black.png"
    },
    {
        index: 3,
        key: "StartLeft",
        icon: "https://images.woosmap.com/directions/turn_slight_left_black.png"
    },
    {
        index: 4,
        key: "Destination",
        icon: "https://images.woosmap.com/directions/straight_black.png"
    },
    {
        index: 5,
        key: "DestinationRight",
        icon: "https://images.woosmap.com/directions/turn_slight_left_black.png"
    },
    {
        index: 6,
        key: "DestinationLeft",
        icon: "https://images.woosmap.com/directions/turn_slight_left_black.png"
    },
    {
        index: 8,
        key: "Continue",
        icon: "https://images.woosmap.com/directions/straight_black.png"
    },
    {
        index: 9,
        key: "SlightRight",
        icon: "https://images.woosmap.com/directions/turn_slight_left_black.png"
    },
    {
        index: 10,
        key: "Right",
        icon: "https://images.woosmap.com/directions/turn_left_black.png"
    },
    {
        index: 11,
        key: "SharpRight",
        icon: "https://images.woosmap.com/directions/turn_left_black.png"
    },
    {
        index: 12,
        key: "UturnRight",
        icon: "https://images.woosmap.com/directions/turn_left_black.png"
    },
    {
        index: 13,
        key: "UturnLeft",
        icon: "https://images.woosmap.com/directions/turn_left_black.png"
    },
    {
        index: 14,
        key: "SharpLeft",
        icon: "https://images.woosmap.com/directions/turn_left_black.png"
    },
    {
        index: 15,
        key: "Left",
        icon: "https://images.woosmap.com/directions/turn_left_black.png"
    },
    {
        index: 16,
        key: "SlightLeft",
        icon: "https://images.woosmap.com/directions/turn_slight_left_black.png"
    },
    {
        index: 17,
        key: "RampStraight",
        icon: "https://images.woosmap.com/directions/straight_black.png"
    },
    {
        index: 18,
        key: "RampRight",
        icon: "https://images.woosmap.com/directions/merge_slight_left_black.png"
    },
    {
        index: 19,
        key: "RampLeft",
        icon: "https://images.woosmap.com/directions/merge_slight_left_black.png"
    },
    {
        index: 20,
        key: "ExitRight",
        icon: "https://images.woosmap.com/directions/merge_left_black.png"
    },
    {
        index: 21,
        key: "ExitLeft",
        icon: "https://images.woosmap.com/directions/merge_left_black.png"
    },
    {
        index: 22,
        key: "StayStraight",
        icon: "https://images.woosmap.com/directions/straight_black.png"
    },
    {
        index: 23,
        key: "StayRight",
        icon: "https://images.woosmap.com/directions/merge_slight_left_black.png"
    },
    {
        index: 24,
        key: "StayLeft",
        icon: "https://images.woosmap.com/directions/merge_slight_left_black.png"
    },
    {
        index: 25,
        key: "Merge",
        icon: "https://images.woosmap.com/directions/merge_black.png"
    },
    {
        index: 26,
        key: "RoundaboutEnter",
        icon: "https://images.woosmap.com/directions/roundabout_black.png"
    },
    {
        index: 27,
        key: "RoundaboutExit",
        icon: "https://images.woosmap.com/directions/roundabout_black.png"
    },
    {
        index: 28,
        key: "FerryEnter",
        icon: "https://images.woosmap.com/directions/boat_black.png"
    },
    {
        index: 29,
        key: "FerryExit",
        icon: "https://images.woosmap.com/directions/boat_black.png"
    },
    {
        index: 37,
        key: "MergeRight",
        icon: "https://images.woosmap.com/directions/merge_left_black.png"
    },
    {
        index: 38,
        key: "MergeLeft",
        icon: "https://images.woosmap.com/directions/merge_left_black.png"
    }
];
var $910b94fe3f3e6ae5$export$2e2bcd8739ae039 = {
    stepsIcon: $910b94fe3f3e6ae5$var$stepsIcon,
    iconsDirections: $910b94fe3f3e6ae5$var$iconsDirections,
    travelModes: $910b94fe3f3e6ae5$var$travelModes,
    unitOptions: $910b94fe3f3e6ae5$var$unitOptions,
    avoidOptions: $910b94fe3f3e6ae5$var$avoidOptions,
    directionsOptions: $910b94fe3f3e6ae5$var$directionsOptions,
    distanceMatrixOptions: $910b94fe3f3e6ae5$var$distanceMatrixOptions
};


const $b14042e311a2078d$var$localitiesConf = {
    minLength: 0,
    data: "advanced",
    types: [
        "locality",
        "postal_code",
        "address",
        "admin_level",
        "airport",
        "train_station",
        "metro_station",
        "shopping",
        "country"
    ]
};
const $b14042e311a2078d$var$searchAPIParameters = {
    stores_by_page: 7,
    radius: 500000
};
const $b14042e311a2078d$var$availableServices = [
    {
        serviceKey: "WF"
    },
    {
        serviceKey: "DT"
    },
    {
        serviceKey: "DR"
    },
    {
        serviceKey: "hrs24"
    },
    {
        serviceKey: "WA"
    },
    {
        serviceKey: "XO"
    },
    {
        serviceKey: "NB"
    },
    {
        serviceKey: "CL"
    }
];
var $b14042e311a2078d$export$2e2bcd8739ae039 = {
    availableServices: $b14042e311a2078d$var$availableServices,
    searchAPIParameters: $b14042e311a2078d$var$searchAPIParameters,
    localitiesConf: $b14042e311a2078d$var$localitiesConf
};


var $f0c5cc45c1859940$var$selectors;
(function(selectors) {
    selectors["mapContainerID"] = "mapContainer";
    selectors["mapWrapperID"] = "mapWrapper";
    selectors["sidebarContainerID"] = "sidebarContainer";
    selectors["sidebarContentContainerID"] = "sidebarContentContainer";
    selectors["searchContainerID"] = "searchContainer";
    selectors["searchWrapperID"] = "searchWrapper";
    selectors["searchInputID"] = "searchInput";
    selectors["filterPanelContainerID"] = "filterPanelContainer";
    selectors["listStoresContainerID"] = "listStoresContainer";
    selectors["detailsStoreContainerID"] = "detailsStoreContainer";
    selectors["directionsContainerID"] = "directionsContainer";
    selectors["travelModeContainerID"] = "travelModeContainer";
    selectors["roadbookContainerID"] = "directionsInstructionsContainer";
})($f0c5cc45c1859940$var$selectors || ($f0c5cc45c1859940$var$selectors = {}));
var $f0c5cc45c1859940$export$2e2bcd8739ae039 = $f0c5cc45c1859940$var$selectors;


var $7fce745404fa0e87$var$urls;
(function(urls) {
    urls["baseApiUrl"] = "https://api.woosmap.com";
    urls["mapJS"] = "https://sdk.woosmap.com/map/map.js";
    urls["localitiesWidgetJS"] = "https://sdk.woosmap.com/localities/localitieswidget.2.0.js";
    urls["localitiesWidgetCSS"] = "https://sdk.woosmap.com/localities/style.2.0.css";
})($7fce745404fa0e87$var$urls || ($7fce745404fa0e87$var$urls = {}));
var $7fce745404fa0e87$export$2e2bcd8739ae039 = $7fce745404fa0e87$var$urls;



const $d0a7dfeff55f6162$export$f84bd70098573c5c = {
    map: (0, $e990629b6dc59f12$export$2e2bcd8739ae039),
    directions: (0, $910b94fe3f3e6ae5$export$2e2bcd8739ae039),
    search: (0, $b14042e311a2078d$export$2e2bcd8739ae039),
    selectors: (0, $f0c5cc45c1859940$export$2e2bcd8739ae039),
    urls: (0, $7fce745404fa0e87$export$2e2bcd8739ae039)
};
let $d0a7dfeff55f6162$var$currentConfig = $d0a7dfeff55f6162$export$f84bd70098573c5c;
function $d0a7dfeff55f6162$export$29b4b847eef7ae1e(configObj) {
    const config = configObj || {};
    return (0, $d1947f3ca833a885$export$4950aa0f605343fb)({
        ...config
    }, {
        ...$d0a7dfeff55f6162$var$currentConfig
    });
}
function $d0a7dfeff55f6162$export$940a7873bb071df8(configObj) {
    $d0a7dfeff55f6162$var$currentConfig = $d0a7dfeff55f6162$export$29b4b847eef7ae1e(configObj);
}
function $d0a7dfeff55f6162$export$44487a86467333c3() {
    return $d0a7dfeff55f6162$var$currentConfig;
}


var $08b91cdba4d81dbe$export$715fed9478e7c158;
(function(MapComponentEvents) {
    MapComponentEvents["STORES_CHANGED"] = "stores_changed";
    MapComponentEvents["STORE_SELECTED"] = "store_selected";
    MapComponentEvents["STORE_UNSELECTED"] = "store_unselected";
    MapComponentEvents["FILTERS_UPDATED"] = "filters_updated";
    MapComponentEvents["MAP_READY"] = "map_ready";
    MapComponentEvents["MAP_IDLE"] = "map_idle";
    MapComponentEvents["LOCATION_CHANGED"] = "location_changed";
})($08b91cdba4d81dbe$export$715fed9478e7c158 || ($08b91cdba4d81dbe$export$715fed9478e7c158 = {}));
class $08b91cdba4d81dbe$export$2e2bcd8739ae039 extends (0, $5c07417a90a15ad5$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$element.id = (0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.mapWrapperID;
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) (0, $3408065cc4bfa60b$export$2cb99e4be0dc4646)({
            url: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().urls.mapJS,
            params: {
                key: this.state.woosmapPublicKey,
                language: (0, $6594c97b430a236e$export$3814be8b8b1016be)().toLowerCase()
            },
            override: true
        }).then(()=>{
            this.initMapView();
        }).catch((error)=>{
            console.error((0, $d1947f3ca833a885$export$77ad94ebf1c2b9ed)((0, $6594c97b430a236e$export$180605366c04f0cd)().errors.loadingLibrary, {
                "library": "Woosmap Map JS SDK script"
            }), error);
        });
    }
    initMapView() {
        this.map = new woosmap.map.Map((0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.mapWrapperID, this.state.mapOptions);
        this.styler = new (0, $c2ef843a781cd26d$export$2e2bcd8739ae039)(this.state.storesStyle);
        this.storesOverlay = new woosmap.map.StoresOverlay(this.state.storesStyle);
        this.storesOverlay.setMap(this.map);
        this.data = new woosmap.map.Data();
        this.data.setMap(this.map);
        this.data.addListener("click", (data)=>{
            const feature = data.feature;
            feature.toGeoJson((geojson)=>{
                this.handleSelectedStore(geojson);
            });
        });
        this.data.setStyle((feature)=>{
            return this.styler.getStyledIcon({
                types: feature.properties.types
            });
        });
        if (this.state.location) {
            this.map.setCenter({
                lat: this.state.location.latitude,
                lng: this.state.location.longitude
            });
            this.map.setZoom(this.state.location.zoom);
        }
        // No style option allows to put a data feature on top of the others (zIndex StyleOptions not implemented yet)
        // Create a second data Layer to handle the selected Store.
        this.dataSelected = new woosmap.map.Data();
        this.dataSelected.setMap(this.map);
        this.dataSelected.setStyle((feature)=>{
            return this.styler.getStyledIcon({
                types: feature.properties.types,
                selected: true
            });
        });
        woosmap.map.event.addListener(this.map, "store_selected", (store)=>{
            this.handleSelectedStore(store);
        });
        woosmap.map.event.addListenerOnce(this.map, "idle", ()=>{
            this.emit("map_idle");
        });
        this.map.addListener("center_changed", (0, $d1947f3ca833a885$export$61fc7d43ac8f84b0)(()=>{
            this.handleLocationChanged();
        }, 150));
        this.on("stores_changed", ()=>{
            this.handleStores();
        });
        this.on("store_selected", ()=>{
            this.selectStore();
        });
        this.on("store_unselected", ()=>{
            this.selectStore();
        });
        this.on("filters_updated", ()=>{
            this.updateFilters();
        });
        this.emit("map_ready");
    }
    handleSelectedStore(store) {
        this.setState({
            selectedStore: store
        }, true, ()=>{
            this.emit("store_selected", this.state.selectedStore);
        });
    }
    handleLocationChanged() {
        this.setState({
            location: {
                zoom: this.map.getZoom(),
                latitude: this.map.getCenter().lat(),
                longitude: this.map.getCenter().lng()
            }
        }, true, ()=>{
            this.emit("location_changed", this.state.location);
        });
    }
    handleStores() {
        if (this.state.stores) {
            if (this.state.stores.length > 0) {
                this.data.setMap(this.map);
                this.data.forEach((feature)=>this.data.remove(feature));
                this.dataSelected.forEach((feature)=>this.dataSelected.remove(feature));
                //create a deepCopy instead of shallowCopy to avoid modifying this.state.stores
                const features = JSON.parse(JSON.stringify(this.state.stores));
                this.data.addGeoJson({
                    type: "FeatureCollection",
                    features: features
                }, {
                    idPropertyName: "store_id"
                });
                const bounds = new woosmap.map.LatLngBounds();
                this.data.forEach((feature)=>{
                    const LatLngPoint = feature.getGeometry();
                    bounds.extend(LatLngPoint.get());
                });
                if (this.state.nearbyLocation) bounds.extend(this.state.nearbyLocation);
                this.map.fitBounds(bounds, this.state.padding);
                this.storesOverlay.setMap(null);
            } else {
                this.storesOverlay.setMap(this.map);
                this.data.setMap(null);
                this.dataSelected.setMap(null);
            }
        }
    }
    unselectStoreOnDataOverlay() {
        this.data.revertStyle();
        this.dataSelected.forEach((feature)=>this.dataSelected.remove(feature));
    }
    selectStoreOnDataOverlay(store) {
        const selectedStore = store ? JSON.parse(JSON.stringify(store)) : JSON.parse(JSON.stringify(this.state.selectedStore));
        let feature = null;
        if (this.data) feature = this.data.getFeatureById(selectedStore.properties.store_id);
        if (feature) {
            this.data.revertStyle();
            this.data.overrideStyle(feature, {
                visible: false
            });
            this.dataSelected.forEach((feature)=>this.dataSelected.remove(feature));
            this.dataSelected.add(feature);
            this.dataSelected.setMap(this.map);
        } else this.storesOverlay.setSelection(selectedStore);
    }
    selectStore() {
        if (this.state.selectedStore) {
            this.selectStoreOnDataOverlay();
            const visibleBounds = this.map.getBounds(this.state.padding);
            const selectedStore = this.state.selectedStore;
            const latLng = {
                lng: selectedStore.geometry.coordinates[0],
                lat: selectedStore.geometry.coordinates[1]
            };
            if (latLng) {
                if (!visibleBounds.contains(latLng)) this.map.panTo(latLng, this.state.padding);
            }
        } else {
            this.storesOverlay.clearSelection();
            this.data.revertStyle();
            this.handleStores();
        }
    }
    updateFilters() {
        if (this.state.query) this.storesOverlay.setQuery(this.state.query);
        else this.storesOverlay.setQuery(undefined);
    }
}






var $6420d13a57ced620$export$862abd191a2ee43;
(function(GeolocationError) {
    GeolocationError["Unavailable"] = "Unavailable";
    GeolocationError["PermissionDenied"] = "PermissionDenied";
    GeolocationError["PositionUnavailable"] = "PositionUnavailable";
    GeolocationError["Timeout"] = "Timeout";
    GeolocationError["Default"] = "Default";
})($6420d13a57ced620$export$862abd191a2ee43 || ($6420d13a57ced620$export$862abd191a2ee43 = {}));
class $6420d13a57ced620$export$68d023cdc03da2f1 {
    static async getCurrentPosition() {
        try {
            return await new Promise((resolve, reject)=>{
                $6420d13a57ced620$export$68d023cdc03da2f1.getNavigatorGeolocation().getCurrentPosition(resolve, reject, $6420d13a57ced620$export$68d023cdc03da2f1.GeolocationOptions);
            });
        } catch (error) {
            throw new Error($6420d13a57ced620$export$68d023cdc03da2f1.getGeolocationError(error));
        }
    }
    static getNavigatorGeolocation() {
        if (!navigator.geolocation) throw new Error("Unavailable");
        return navigator.geolocation;
    }
    static isGeolocationError(error) {
        return typeof error === "object" && "PERMISSION_DENIED" in error;
    }
    static getGeolocationError(error) {
        console.error((0, $6594c97b430a236e$export$180605366c04f0cd)().errors.geolocationFailed, error);
        if ($6420d13a57ced620$export$68d023cdc03da2f1.isGeolocationError(error)) switch(error.code){
            case error.PERMISSION_DENIED:
                return "PermissionDenied";
            case error.POSITION_UNAVAILABLE:
                return "PositionUnavailable";
            case error.TIMEOUT:
                return "Timeout";
            default:
                return "Default";
        }
        else if (error.message === "Unavailable") return "Unavailable";
        else return "Default";
    }
}
$6420d13a57ced620$export$68d023cdc03da2f1.GeolocationOptions = {
    enableHighAccuracy: true,
    timeout: 6000,
    maximumAge: 30000
};



var $2957022deaac1183$export$d34e68953e15144d;
(function(GeolocateComponentEvents) {
    GeolocateComponentEvents["GEOLOCATION_FOUND"] = "geolocation_found";
    GeolocateComponentEvents["GEOLOCATION_ERROR"] = "geolocation_error";
})($2957022deaac1183$export$d34e68953e15144d || ($2957022deaac1183$export$d34e68953e15144d = {}));
class $2957022deaac1183$export$2e2bcd8739ae039 extends (0, $5c07417a90a15ad5$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
    }
    render() {
        if (this.state && this.$element) {
            this.$element.className = "search__geolocateBtn";
            this.$element.innerHTML = `<button type="button" aria-label="${(0, $6594c97b430a236e$export$180605366c04f0cd)().search.yourLocation}"></button>`;
            this.$element.addEventListener("click", async ()=>{
                this.$element.classList.add("active");
                await this.getLocation().then(()=>{
                    this.$element.classList.remove("active");
                });
            });
            this.$target.appendChild(this.$element);
        }
    }
    setPosition(geoPosition) {
        const { latitude: latitude, longitude: longitude, altitude: altitude, accuracy: accuracy } = geoPosition.coords;
        this.setState({
            position: {
                name: (0, $6594c97b430a236e$export$180605366c04f0cd)().search.yourLocation,
                timestamp: Date.now(),
                latitude: latitude,
                longitude: longitude,
                altitude: altitude,
                accuracy: accuracy
            }
        }, true, ()=>{
            this.emit("geolocation_found", this.state.position);
        });
    }
    async getLocation() {
        try {
            const position = await (0, $6420d13a57ced620$export$68d023cdc03da2f1).getCurrentPosition();
            this.setPosition(position);
        } catch (error) {
            this.onGeolocationError(error);
        }
    }
    onGeolocationError(error) {
        this.setState({
            error: error,
            position: undefined
        }, true, ()=>{
            this.emit("geolocation_error");
        });
    }
}


/**
 * Previously loading/loaded css stylesheets that have been requested by `loadCss()`.
 */ let $5e50f2bc8724b22f$var$cachedCss = {};
function $5e50f2bc8724b22f$export$82219ea58a717c3f(href) {
    const existing = $5e50f2bc8724b22f$var$cachedCss[href];
    if (existing) return existing;
    const promise = new Promise((resolve, reject)=>{
        if ($5e50f2bc8724b22f$var$findCss(href)) resolve();
        const css = $5e50f2bc8724b22f$var$createLinkElement(href);
        const onCssLoad = ()=>{
            resolve();
        };
        const onCssError = ()=>{
            cleanup();
            delete $5e50f2bc8724b22f$var$cachedCss[href];
            css.remove();
            const defaultError = new Error(`The css "${href}" failed to load.`);
            reject(defaultError);
        };
        css.addEventListener("load", onCssLoad);
        css.addEventListener("error", onCssError);
        document.head.insertBefore(css, document.head.firstElementChild);
        function cleanup() {
            css.removeEventListener("load", onCssLoad);
            css.removeEventListener("error", onCssError);
        }
    });
    $5e50f2bc8724b22f$var$cachedCss[href] = promise;
    return promise;
}
/**
 * Find css href in the DOM
 * @param {string} href - used to set the css href.
 * @return {boolean | null} returns `true` if css link exist otherwise `null`.
 */ function $5e50f2bc8724b22f$var$findCss(href) {
    const currentCss = document.querySelector(`link[href="${href}"]`);
    if (currentCss === null) return null;
    return true;
}
/**
 * Creates Link Element
 * @param {string} href - the css href
 * @return {HTMLScriptElement} returns the newly created script.
 */ function $5e50f2bc8724b22f$var$createLinkElement(href) {
    const newLink = document.createElement("link");
    newLink.rel = "stylesheet";
    newLink.type = "text/css";
    newLink.href = href;
    return newLink;
}
function $5e50f2bc8724b22f$export$a19643d5acb30753() {
    $5e50f2bc8724b22f$var$cachedCss = {};
}





var $6764db29c49c590e$export$bec4f8eff0df0668;
(function(SearchComponentEvents) {
    SearchComponentEvents["SELECTED_LOCALITY"] = "selected_locality";
    SearchComponentEvents["SEARCH_CLEAR"] = "search_clear";
})($6764db29c49c590e$export$bec4f8eff0df0668 || ($6764db29c49c590e$export$bec4f8eff0df0668 = {}));
class $6764db29c49c590e$export$2e2bcd8739ae039 extends (0, $5c07417a90a15ad5$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("input");
        this.$element.className = "search__input";
        this.$element.setAttribute("placeholder", (0, $6594c97b430a236e$export$180605366c04f0cd)().search.placeholder);
        this.$element.setAttribute("aria-label", (0, $6594c97b430a236e$export$180605366c04f0cd)().search.placeholder);
        this.$element.setAttribute("aria-autocomplete", "list");
        this.$element.setAttribute("autocomplete", "off");
        this.$element.id = this.state.inputID;
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) (0, $3408065cc4bfa60b$export$2cb99e4be0dc4646)({
            url: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().urls.localitiesWidgetJS,
            params: {
                key: this.state.woosmapPublicKey
            }
        }).then(()=>(0, $5e50f2bc8724b22f$export$82219ea58a717c3f)((0, $d0a7dfeff55f6162$export$44487a86467333c3)().urls.localitiesWidgetCSS)).then(()=>this.initSearchView()).catch((error)=>{
            console.error((0, $d1947f3ca833a885$export$77ad94ebf1c2b9ed)((0, $6594c97b430a236e$export$180605366c04f0cd)().errors.loadingLibrary, {
                "library": "Woosmap Localities JS Widget"
            }), error);
        });
    }
    initSearchView() {
        const searchOptions = (0, $d1947f3ca833a885$export$4950aa0f605343fb)({
            ...this.state.searchOptions
        }, {
            language: (0, $6594c97b430a236e$export$3814be8b8b1016be)().toLowerCase()
        });
        this.localitiesWidget = new woosmap.localities.Autocomplete(this.state.inputID, searchOptions);
        this.localitiesWidget.addListener("selected_suggestion", ()=>{
            const locality = this.localitiesWidget.getSelectedSuggestionDetails();
            const searchLocation = {
                name: locality.formatted_address || locality.name,
                publicId: locality.public_id,
                location: locality.geometry.location
            };
            this.setState({
                selectedLocality: searchLocation
            }, true);
            this.emit("selected_locality", searchLocation);
        });
        const $inputContainer = document.getElementById(this.state.inputID).parentElement;
        this.state.featuresBtn.forEach((feature)=>{
            if (feature === "search") this.manageSearchButton($inputContainer);
            if (feature === "clear") this.manageClearButton($inputContainer);
            if (feature === "geolocate") this.manageGeolocateButton($inputContainer);
        });
    }
    selectLocality() {
        if (this.state.selectedLocality) {
            this.setLocality(this.state.selectedLocality.name || "");
            this.emit("selected_locality", this.state.selectedLocality);
        }
    }
    manageSearchButton($inputContainer) {
        const $searchBtn = document.createElement("div");
        $searchBtn.className = "search__searchBtn";
        $searchBtn.innerHTML = `<button type="button" aria-label="${(0, $6594c97b430a236e$export$180605366c04f0cd)().search.submitLabel}"></button>`;
        $searchBtn.addEventListener("click", ()=>{
            if (this.state.selectedLocality) this.emit("selected_locality", this.state.selectedLocality);
            else this.$element.focus();
        });
        $inputContainer.appendChild($searchBtn);
    }
    manageClearButton($inputContainer) {
        const $clearBtn = document.createElement("div");
        $clearBtn.className = "search__clearBtn";
        $clearBtn.innerHTML = `<button type="button" aria-label="${(0, $6594c97b430a236e$export$180605366c04f0cd)().search.clearLabel}"></button>`;
        $clearBtn.addEventListener("click", ()=>this.handleClearBtnClick($clearBtn, $inputContainer));
        [
            "input",
            "locality_changed"
        ].forEach((evt)=>this.$element.addEventListener(evt, ()=>this.handleInputChange($clearBtn)));
        $clearBtn.style.display = "none";
        $inputContainer.appendChild($clearBtn);
    }
    setLocality(name) {
        const observer = new MutationObserver((mutationsList, observer)=>{
            if (this.$element && this.$element instanceof HTMLInputElement && this.$target.querySelector(".search__clearBtn")) {
                this.$element.value = name;
                this.$element.dispatchEvent(new Event("locality_changed"));
                observer.disconnect();
            }
        });
        observer.observe(document, {
            childList: true,
            subtree: true
        });
    }
    manageGeolocateButton($inputContainer) {
        const geolocateComponent = new (0, $2957022deaac1183$export$2e2bcd8739ae039)({
            $target: $inputContainer,
            initialState: {}
        });
        geolocateComponent.on((0, $2957022deaac1183$export$d34e68953e15144d).GEOLOCATION_FOUND, (geolocation)=>{
            if (geolocation) {
                const searchLocation = {
                    name: geolocation.name,
                    location: {
                        lat: geolocation.latitude,
                        lng: geolocation.longitude
                    }
                };
                this.setLocality((0, $6594c97b430a236e$export$180605366c04f0cd)().search.yourLocation);
                this.setState({
                    selectedLocality: searchLocation
                }, true);
                this.emit("selected_locality", searchLocation);
            }
        });
    }
    constructor(...args){
        super(...args);
        this.handleClearBtnClick = ($clearBtn, $inputContainer)=>{
            const $emptyButton = $inputContainer.querySelector(".localities-empty-button");
            if ($emptyButton) {
                $emptyButton.click();
                $clearBtn.style.display = "none";
            } else {
                this.$element.value = "";
                $clearBtn.style.display = "none";
                this.$element.focus();
            }
            this.emit("search_clear");
        };
        this.handleInputChange = ($clearBtn)=>{
            if (this.$element.value.length === 0) $clearBtn.style.display = "none";
            else $clearBtn.style.display = "block";
        };
    }
}





function $3f67fabed7c8b4f3$export$a4b8ee4ccc3b7327(address) {
    if (!address) return "";
    const readableAddress = [];
    if (typeof address.lines !== "undefined" && address.lines.length >= 0) readableAddress.push(...address.lines);
    if (address.zipcode) readableAddress.push(address.zipcode);
    if (address.city) readableAddress.push(address.city);
    return readableAddress.join(", ");
}
function $3f67fabed7c8b4f3$export$5f1d97f53c43eb95(distance, unitSystem = "metric") {
    if (!distance) return "";
    let readableDistance;
    const meterToYard = 1.09361;
    const unitSystemValues = {
        metric: {
            unit: "km",
            smallUnit: "m",
            factor: 1000
        },
        imperial: {
            unit: "mi",
            smallUnit: "yd",
            factor: 1760
        }
    };
    const system = unitSystemValues["metric"];
    if (unitSystem === "imperial") distance *= meterToYard;
    if (distance < system.factor) readableDistance = Math.round(distance) + "\xa0" + system.smallUnit;
    else readableDistance = parseFloat((distance / system.factor).toFixed(1)) + "\xa0" + system.unit;
    return readableDistance;
}
function $3f67fabed7c8b4f3$export$adee39cd77054230(contact) {
    if (!contact || !contact.phone) return "";
    const $contactLink = document.createElement("a");
    $contactLink.className = "contactPhone";
    $contactLink.href = `tel:${contact.phone}`;
    $contactLink.text = contact.phone;
    return $contactLink.outerHTML;
}
function $3f67fabed7c8b4f3$export$480cc82b47a34531(contact) {
    if (!contact || !contact.website) return "";
    const $websiteLink = document.createElement("a");
    $websiteLink.className = "contactWebsite";
    $websiteLink.href = `${contact.website}`;
    $websiteLink.target = `_blank`;
    $websiteLink.text = (0, $6594c97b430a236e$export$180605366c04f0cd)().stores.cta.website;
    return $websiteLink.outerHTML;
}
function $3f67fabed7c8b4f3$export$474367fb1a91710b(servicesList) {
    const storeServices = servicesList.map((service)=>(0, $d0a7dfeff55f6162$export$44487a86467333c3)().search.availableServices.filter(({ serviceKey: serviceKey })=>serviceKey === service)[0]).filter((x)=>x);
    const $storeServices = document.createElement("ul");
    $storeServices.className = "detailsStore__services";
    const servicesHTML = storeServices.map((service)=>{
        const $service = document.createElement("li");
        $service.dataset.servicekey = service.serviceKey;
        $service.dataset.servicename = (0, $6594c97b430a236e$export$236350842f3cd9bc)((0, $6594c97b430a236e$export$180605366c04f0cd)().filtering.services, service.serviceKey);
        $service.innerHTML = `
        <div class='iconService iconService__${service.serviceKey}'></div>
        <div class='serviceName'>${(0, $6594c97b430a236e$export$236350842f3cd9bc)((0, $6594c97b430a236e$export$180605366c04f0cd)().filtering.services, service.serviceKey)}</div>`;
        return $service;
    });
    $storeServices.append(...servicesHTML);
    return $storeServices.outerHTML;
}
function $3f67fabed7c8b4f3$export$a1781a8729551ae5(store) {
    let openLabel = "";
    function _convertTime(UNIX_timestamp) {
        const a = new Date(UNIX_timestamp * 1000);
        return a.toLocaleString((0, $6594c97b430a236e$export$3814be8b8b1016be)(), {
            weekday: "long",
            day: "numeric",
            month: "short"
        });
    }
    try {
        var _store_open, _store_open1;
        if ((_store_open = store.open) === null || _store_open === void 0 ? void 0 : _store_open.open_now) {
            openLabel = `${(0, $6594c97b430a236e$export$180605366c04f0cd)().time.openUntil} ${store.open.current_slice.end}`;
            if (store.weekly_opening) {
                if (store.open.current_slice.end) openLabel = `${(0, $6594c97b430a236e$export$180605366c04f0cd)().time.openUntil} ${store.open.current_slice.end}`;
                else if (store.open.current_slice["all-day"]) openLabel = (0, $6594c97b430a236e$export$180605366c04f0cd)().time.open24_7;
            } else {
                if (store.open.current_slice.end) openLabel = `${(0, $6594c97b430a236e$export$180605366c04f0cd)().time.openUntil} ${store.open.current_slice.end}`;
                else if (store.open.current_slice["all-day"]) openLabel = (0, $6594c97b430a236e$export$180605366c04f0cd)().time.open24_7;
            }
        } else if ((_store_open1 = store.open) === null || _store_open1 === void 0 ? void 0 : _store_open1.next_opening) {
            var _store_open2;
            if ($3f67fabed7c8b4f3$var$isToday(new Date((_store_open2 = store.open) === null || _store_open2 === void 0 ? void 0 : _store_open2.next_opening.day))) openLabel += openLabel += `${(0, $6594c97b430a236e$export$180605366c04f0cd)().time.opensToday} ${(0, $6594c97b430a236e$export$180605366c04f0cd)().time.at} ${store.open.next_opening.start}`;
            else openLabel += `${(0, $6594c97b430a236e$export$180605366c04f0cd)().time.opens} ${_convertTime(Date.parse(store.open.next_opening.day) / 1000)} ${(0, $6594c97b430a236e$export$180605366c04f0cd)().time.at} ${store.open.next_opening.start}`;
        } else openLabel = `${(0, $6594c97b430a236e$export$180605366c04f0cd)().time.closed}`;
        return openLabel;
    } catch (error) {
        return "";
    }
}
function $3f67fabed7c8b4f3$export$68d7463414e9d987(weeklyOpening) {
    const readableOpeningHours = {
        "1": {
            dayName: (0, $6594c97b430a236e$export$180605366c04f0cd)().time.dayOfWeek[0],
            hoursDay: ""
        },
        "2": {
            dayName: (0, $6594c97b430a236e$export$180605366c04f0cd)().time.dayOfWeek[1],
            hoursDay: ""
        },
        "3": {
            dayName: (0, $6594c97b430a236e$export$180605366c04f0cd)().time.dayOfWeek[2],
            hoursDay: ""
        },
        "4": {
            dayName: (0, $6594c97b430a236e$export$180605366c04f0cd)().time.dayOfWeek[3],
            hoursDay: ""
        },
        "5": {
            dayName: (0, $6594c97b430a236e$export$180605366c04f0cd)().time.dayOfWeek[4],
            hoursDay: ""
        },
        "6": {
            dayName: (0, $6594c97b430a236e$export$180605366c04f0cd)().time.dayOfWeek[5],
            hoursDay: ""
        },
        "7": {
            dayName: (0, $6594c97b430a236e$export$180605366c04f0cd)().time.dayOfWeek[0],
            hoursDay: ""
        }
    };
    const $storeOpeningWeek = document.createElement("ul");
    $storeOpeningWeek.className = "storeDetails__openingWeek";
    const today = new Date().toLocaleString((0, $6594c97b430a236e$export$3814be8b8b1016be)(), {
        weekday: "long"
    });
    Object.entries(weeklyOpening).forEach(([day, hoursPeriod])=>{
        if (!hoursPeriod || hoursPeriod.length === 0) readableOpeningHours[day].hoursDay = (0, $6594c97b430a236e$export$180605366c04f0cd)().time.closed;
        else if (readableOpeningHours[day]) {
            var _hoursPeriod_hours;
            if (readableOpeningHours[day].dayName === today) readableOpeningHours[day].today = true;
            if (((_hoursPeriod_hours = hoursPeriod.hours) === null || _hoursPeriod_hours === void 0 ? void 0 : _hoursPeriod_hours.length) === 0) readableOpeningHours[day].hoursDay = (0, $6594c97b430a236e$export$180605366c04f0cd)().time.closed;
            else readableOpeningHours[day].hoursDay = $3f67fabed7c8b4f3$var$concatenateStoreHours(hoursPeriod.hours);
        }
    });
    const hoursHTML = Object.entries(readableOpeningHours).map(([dayIndex, dayValues])=>{
        const $listDay = document.createElement("li");
        $listDay.className = dayValues.today ? "currentDay" : "";
        $listDay.innerHTML = `<span class='day ${dayIndex}'>${dayValues.dayName}</span><span class='hours'>${dayValues.hoursDay}</span>`;
        return $listDay;
    });
    $storeOpeningWeek.append(...hoursHTML);
    return $storeOpeningWeek.outerHTML;
}
function $3f67fabed7c8b4f3$var$isToday(date) {
    const today = new Date();
    return today.toDateString() === date.toDateString();
}
function $3f67fabed7c8b4f3$var$concatenateStoreHours(openHours) {
    const hoursText = [];
    let end = "";
    openHours.forEach((period)=>{
        if ("all-day" in period || period.end === "00:00" && period.start === "00:00") return "24h/24";
        end = period.end;
        hoursText.push(`${period.start}\u{2013}${end}`);
    });
    return hoursText.join(", ");
}



var $72b71f2c4b6f4878$export$fc087719351cdb12;
(function(StoreDetailsComponentEvents) {
    StoreDetailsComponentEvents["DIRECTIONS_SHOW"] = "directions_show";
    StoreDetailsComponentEvents["BACK"] = "back";
})($72b71f2c4b6f4878$export$fc087719351cdb12 || ($72b71f2c4b6f4878$export$fc087719351cdb12 = {}));
class $72b71f2c4b6f4878$export$2e2bcd8739ae039 extends (0, $5c07417a90a15ad5$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) {
            if (this.state.store) {
                var _properties_tags;
                const properties = this.state.store.properties;
                const htmlElements = [];
                const $backBtn = this.getBackButton();
                const $storeDetailsHeader = this.getDetailsHeader(properties);
                const $storeDetailsActions = this.getActionsButtons(properties);
                const $storeDetails = document.createElement("div");
                $storeDetails.className = "detailsStore";
                $storeDetails.innerHTML = `
                             ${properties.weekly_opening ? `<div class="detailsStore__content detailsStore__listItems"><div class="detailsStore__headerList">${(0, $6594c97b430a236e$export$180605366c04f0cd)().time.openingHoursTitle}</div>${(0, $3f67fabed7c8b4f3$export$68d7463414e9d987)(properties.weekly_opening)}</div>` : ""}
                             ${((_properties_tags = properties.tags) === null || _properties_tags === void 0 ? void 0 : _properties_tags.length) ? `<div class="detailsStore__content detailsStore__listItems"><div class="detailsStore__headerList">${(0, $6594c97b430a236e$export$180605366c04f0cd)().filtering.servicesTitle}</div>${(0, $3f67fabed7c8b4f3$export$474367fb1a91710b)(properties.tags)}</div>` : ""}`;
                htmlElements.push($backBtn, $storeDetailsHeader, $storeDetailsActions, $storeDetails);
                this.$target.replaceChildren(...htmlElements);
            }
        }
    }
    getDetailsHeader(properties) {
        var _properties_types;
        const $storeDetailsHeader = document.createElement("div");
        $storeDetailsHeader.className = "detailsStore";
        $storeDetailsHeader.innerHTML = `
                             <div class="detailsStore__thumbnail"><div class="detailsStore__thumbnailImg"></div></div>
                             <div class="detailsStore__content detailsStore__name">${properties.name}</div>
                             ${((_properties_types = properties.types) === null || _properties_types === void 0 ? void 0 : _properties_types.length) ? `<div class="detailsStore__content detailsStore__types">${properties.types.join(" ,")}</div>` : ""}                             
                             ${properties.open ? `<div class="detailsStore__content detailsStore__opening">${(0, $3f67fabed7c8b4f3$export$a1781a8729551ae5)(properties)}</div>` : ""}
                             ${properties.address ? `<div class="detailsStore__content detailsStore__address">${(0, $3f67fabed7c8b4f3$export$a4b8ee4ccc3b7327)(properties.address)}</div>` : ""}`;
        return $storeDetailsHeader;
    }
    getActionsButtons(properties) {
        var _properties_contact, _properties_contact1;
        const $storeDetailsActions = document.createElement("div");
        $storeDetailsActions.className = "detailsStore__content detailsStore__actions";
        const $directionsBtn = document.createElement("button");
        $directionsBtn.className = "button";
        $directionsBtn.addEventListener("click", ()=>this.emit("directions_show", this.state.store));
        $directionsBtn.innerHTML = `<div class="buttonIcon directionsButton"></div><span>${(0, $6594c97b430a236e$export$180605366c04f0cd)().stores.cta.directions}</span>`;
        $storeDetailsActions.appendChild($directionsBtn);
        if ((_properties_contact = properties.contact) === null || _properties_contact === void 0 ? void 0 : _properties_contact.phone) {
            const $phoneBtn = document.createElement("button");
            $phoneBtn.className = "button";
            $phoneBtn.innerHTML = `<div class="buttonIcon phoneButton"></div><span>${(0, $6594c97b430a236e$export$180605366c04f0cd)().stores.cta.call}</span>`;
            $phoneBtn.addEventListener("click", ()=>{
                var _properties_contact;
                window.open(`tel:${(_properties_contact = properties.contact) === null || _properties_contact === void 0 ? void 0 : _properties_contact.phone}`, "_self");
            });
            $storeDetailsActions.appendChild($phoneBtn);
        }
        if ((_properties_contact1 = properties.contact) === null || _properties_contact1 === void 0 ? void 0 : _properties_contact1.website) {
            const $websiteBtn = document.createElement("button");
            $websiteBtn.className = "button";
            $websiteBtn.innerHTML = `<div class="buttonIcon websiteButton"></div><span>${(0, $6594c97b430a236e$export$180605366c04f0cd)().stores.cta.website}</span>`;
            $websiteBtn.addEventListener("click", ()=>{
                var _properties_contact;
                window.open(`${(_properties_contact = properties.contact) === null || _properties_contact === void 0 ? void 0 : _properties_contact.website}`, "_blank");
            });
            $storeDetailsActions.appendChild($websiteBtn);
        }
        return $storeDetailsActions;
    }
    getBackButton() {
        const $headerContainer = document.createElement("div");
        $headerContainer.className = "detailsStore__header";
        const $backBtn = document.createElement("button");
        $backBtn.className = "backButton";
        $backBtn.addEventListener("click", ()=>this.emit("back"));
        $backBtn.innerHTML = `<div class="backButton__icon"></div>`;
        $headerContainer.innerHTML = `<div class="detailsStore__headerTitle"></div>`;
        $headerContainer.appendChild($backBtn);
        return $headerContainer;
    }
}





class $cd7c78e63e90c532$export$2e2bcd8739ae039 {
    async call(path, params, init) {
        params.key = this.apiKey;
        const apiUrl = `${this.baseUrl}${path}?${(0, $d1947f3ca833a885$export$89a7e74069fbb7af)(params)}`;
        return await fetch(apiUrl, {
            ...init
        });
    }
    constructor(params){
        this.apiKey = params.apiKey;
        this.baseUrl = params.baseUrl;
    }
}



class $1a0c167730d0ee44$export$2e2bcd8739ae039 {
    searchStores({ ...params }) {
        const apiPath = "/stores/search/";
        const options = {
            method: "GET",
            headers: {
                Accept: "application/json"
            }
        };
        return this.httpClient.call(apiPath, params, options).then((response)=>{
            return this.processSearchStores(response);
        });
    }
    processSearchStores(response) {
        const status = response.status;
        if (status === 200) return response.json().then((data)=>{
            return data;
        });
        else if (status === 401) throw new Error((0, $6594c97b430a236e$export$180605366c04f0cd)().errors.apiErrors["401"]);
        else if (status === 403) throw new Error((0, $6594c97b430a236e$export$180605366c04f0cd)().errors.apiErrors["403"]);
        else if (status === 429) throw new Error((0, $6594c97b430a236e$export$180605366c04f0cd)().errors.apiErrors["429"]);
        else if (status === 500) throw new Error((0, $6594c97b430a236e$export$180605366c04f0cd)().errors.apiErrors["500"]);
        else if (status !== 200 && status !== 204) throw new Error((0, $6594c97b430a236e$export$180605366c04f0cd)().errors.apiErrors.other);
        return Promise.resolve(null);
    }
    constructor(httpClient){
        this.httpClient = httpClient;
    }
}



class $cc5da7dc633f52d7$export$2e2bcd8739ae039 {
    route({ ...params }) {
        const apiPath = "/distance/route/json";
        const options = {
            method: "GET",
            headers: {
                Accept: "application/json"
            }
        };
        return this.httpClient.call(apiPath, params, options).then((response)=>{
            return this.processRoute(response);
        });
    }
    processRoute(response) {
        const status = response.status;
        if (status === 200) return response.json().then((data)=>{
            return data;
        });
        else if (status === 401) throw new Error((0, $6594c97b430a236e$export$180605366c04f0cd)().errors.apiErrors["401"]);
        else if (status === 403) throw new Error((0, $6594c97b430a236e$export$180605366c04f0cd)().errors.apiErrors["403"]);
        else if (status === 429) throw new Error((0, $6594c97b430a236e$export$180605366c04f0cd)().errors.apiErrors["429"]);
        else if (status === 500) throw new Error((0, $6594c97b430a236e$export$180605366c04f0cd)().errors.apiErrors["500"]);
        else if (status !== 200 && status !== 204) throw new Error((0, $6594c97b430a236e$export$180605366c04f0cd)().errors.apiErrors.other);
        return Promise.resolve(null);
    }
    constructor(httpClient){
        this.httpClient = httpClient;
    }
}



class $91b6a6d3a7626477$export$e91aad2e7ca3cca3 {
    get stores() {
        return this._stores;
    }
    get distance() {
        return this._distance;
    }
    constructor(params){
        this.httpClient = new (0, $cd7c78e63e90c532$export$2e2bcd8739ae039)({
            ...params,
            baseUrl: params.baseUrl || (0, $d0a7dfeff55f6162$export$44487a86467333c3)().urls.baseApiUrl,
            apiKey: params.apiKey || (0, $d0a7dfeff55f6162$export$44487a86467333c3)().map.woosmapPublicKey
        });
        this._stores = new (0, $1a0c167730d0ee44$export$2e2bcd8739ae039)(this.httpClient);
        this._distance = new (0, $cc5da7dc633f52d7$export$2e2bcd8739ae039)(this.httpClient);
    }
}


var $3fdc1df19c40b662$exports = {};

$3fdc1df19c40b662$exports = (parcelRequire("1epfE")).getBundleURL("eaJHN") + "empty.8a55106f.jpg";




var $f0ae777be0abac32$export$e16b04041918aede;
(function(StoresListComponentEvents) {
    StoresListComponentEvents["STORES_CHANGED"] = "stores_changed";
    StoresListComponentEvents["LOCALITY_CHANGED"] = "locality_changed";
    StoresListComponentEvents["QUERY_CHANGED"] = "query_changed";
    StoresListComponentEvents["STORE_SELECTED"] = "store_selected";
    StoresListComponentEvents["STORE_MOUSEENTER"] = "store_mouseenter";
    StoresListComponentEvents["STORE_MOUSELEAVE"] = "store_mouseleave";
})($f0ae777be0abac32$export$e16b04041918aede || ($f0ae777be0abac32$export$e16b04041918aede = {}));
class $f0ae777be0abac32$export$2e2bcd8739ae039 extends (0, $5c07417a90a15ad5$export$2e2bcd8739ae039) {
    init() {
        this.api = new (0, $91b6a6d3a7626477$export$e91aad2e7ca3cca3)({
            apiKey: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().map.woosmapPublicKey
        });
        this.$element = document.createElement("ul");
        this.$target.appendChild(this.$element);
        this.on("locality_changed", ()=>{
            this.searchStores();
        });
        this.on("query_changed", ()=>{
            this.searchStores();
        });
    }
    render() {
        if (this.state && this.$element) {
            var _this_state_stores;
            if ((_this_state_stores = this.state.stores) === null || _this_state_stores === void 0 ? void 0 : _this_state_stores.length) {
                var _this_state_stores1;
                const storesElements = (_this_state_stores1 = this.state.stores) === null || _this_state_stores1 === void 0 ? void 0 : _this_state_stores1.map((store)=>{
                    var _properties_contact, _properties_user_properties, _properties_user_properties1;
                    const properties = store.properties;
                    const $storeElement = document.createElement("li");
                    $storeElement.className = "summaryStore";
                    $storeElement.dataset.storeId = store.properties.store_id;
                    $storeElement.innerHTML = `
                            <div class="summaryStore__name">${store.properties.name}</div>
                            ${properties.address ? `<div class="summaryStore__address">${(0, $3f67fabed7c8b4f3$export$a4b8ee4ccc3b7327)(properties.address)}</div>` : ""}
                            ${((_properties_contact = properties.contact) === null || _properties_contact === void 0 ? void 0 : _properties_contact.phone) ? `<div class="summaryStore__phone">${(0, $3f67fabed7c8b4f3$export$adee39cd77054230)(properties.contact)}</div>` : ""}
                            ${((_properties_user_properties = properties.user_properties) === null || _properties_user_properties === void 0 ? void 0 : _properties_user_properties.distance) ? `<div class="summaryStore__distance">${((_properties_user_properties1 = properties.user_properties) === null || _properties_user_properties1 === void 0 ? void 0 : _properties_user_properties1.distance).text}</div>` : properties.distance ? `<div class="summaryStore__distance">${(0, $3f67fabed7c8b4f3$export$5f1d97f53c43eb95)(properties.distance)}</div>` : ""}`;
                    $storeElement.addEventListener("click", ()=>{
                        this.emit("store_selected", store);
                    });
                    $storeElement.addEventListener("mouseenter", ()=>{
                        this.emit("store_mouseenter", store);
                    });
                    $storeElement.addEventListener("mouseleave", ()=>{
                        this.emit("store_mouseleave", store);
                    });
                    return $storeElement;
                });
                this.$element.replaceChildren(...storesElements);
            } else {
                const $emptyResults = document.createElement("div");
                const messageHeader = this.state.stores ? (0, $6594c97b430a236e$export$180605366c04f0cd)().stores.messages.emptyHeader : (0, $6594c97b430a236e$export$180605366c04f0cd)().stores.messages.initialHeader;
                const messageBody = this.state.stores ? (0, $6594c97b430a236e$export$180605366c04f0cd)().stores.messages.emptyBody : (0, $6594c97b430a236e$export$180605366c04f0cd)().stores.messages.initialBody;
                $emptyResults.innerHTML = `
                <div class="summaryStore__empty">
                    <div>
                        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($3fdc1df19c40b662$exports))}" width="120">
                    </div>
                    <h3>${messageHeader}</h3>
                    <div>${messageBody}</div>
                <div>`;
                this.$element.replaceChildren($emptyResults);
            }
        }
    }
    searchStores() {
        if (this.state.nearbyLocation) {
            let params = Object.assign({}, (0, $d0a7dfeff55f6162$export$44487a86467333c3)().search.searchAPIParameters, {
                lat: this.state.nearbyLocation.lat,
                lng: this.state.nearbyLocation.lng
            });
            if (this.state.query) params = Object.assign({}, params, {
                query: this.state.query
            });
            this.api.stores.searchStores(params).then((response)=>{
                const storesList = response === null || response === void 0 ? void 0 : response.features.map((store)=>store);
                this.updateStoresWithDistanceMatrix(storesList).then((updatedStores)=>{
                    this.setState({
                        stores: updatedStores
                    });
                    this.emit("stores_changed", this.state);
                });
            }).catch((exception)=>{
                console.error(exception);
                this.setState({
                    stores: []
                });
            });
        }
    }
    updateStoresWithDistanceMatrix(stores) {
        return new Promise((resolve, reject)=>{
            const distanceService = new woosmap.map.DistanceService();
            const distanceMatrixRequest = {
                ...(0, $d0a7dfeff55f6162$export$44487a86467333c3)().directions.distanceMatrixOptions,
                origins: [
                    this.state.nearbyLocation
                ],
                destinations: stores.map((store)=>{
                    return {
                        lat: store.geometry.coordinates[1],
                        lng: store.geometry.coordinates[0]
                    };
                })
            };
            distanceService.getDistanceMatrix(distanceMatrixRequest).then((response)=>{
                if (response.status === "OK") {
                    stores.forEach((store, i)=>{
                        const result = response.rows[0].elements[i];
                        if (result.status === "OK") {
                            store.properties.user_properties = store.properties.user_properties || {};
                            var _result_distance;
                            store.properties.user_properties["distance"] = (_result_distance = result.distance) !== null && _result_distance !== void 0 ? _result_distance : store.properties.user_properties["distance"];
                        }
                    });
                    stores.sort((a, b)=>{
                        var _a_properties_user_properties, _b_properties_user_properties;
                        return (((_a_properties_user_properties = a.properties.user_properties) === null || _a_properties_user_properties === void 0 ? void 0 : _a_properties_user_properties.distance).value || 0) - (((_b_properties_user_properties = b.properties.user_properties) === null || _b_properties_user_properties === void 0 ? void 0 : _b_properties_user_properties.distance).value || 0);
                    });
                }
                resolve(stores); // Resolve with stores even if Distance Matrix request failed
            }).catch((error)=>{
                console.error(error);
                reject(error);
            });
        });
    }
}






var $8ad82d7eb9e1a62d$export$f5c69f55b3b1a646;
(function(FilterComponentEvents) {
    FilterComponentEvents["FILTERS_UPDATED"] = "filters_updated";
})($8ad82d7eb9e1a62d$export$f5c69f55b3b1a646 || ($8ad82d7eb9e1a62d$export$f5c69f55b3b1a646 = {}));
class $8ad82d7eb9e1a62d$export$2e2bcd8739ae039 extends (0, $5c07417a90a15ad5$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$element.className = "filterHeader collapsible";
        this.$element.innerHTML = `<span class="collapsibleTitle">${(0, $6594c97b430a236e$export$180605366c04f0cd)().filtering.servicesTitle}</span><div class="collapsibleIcon"></div>`;
        this.$element.addEventListener("click", ()=>this.toggleActive());
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) {
            const $listServices = document.createElement("ul");
            $listServices.className = "filterList collapsibleContent";
            const servicesHTML = (0, $d0a7dfeff55f6162$export$44487a86467333c3)().search.availableServices.map((service)=>{
                const $service = document.createElement("li");
                $service.dataset.servicekey = service.serviceKey;
                $service.dataset.servicename = (0, $6594c97b430a236e$export$236350842f3cd9bc)((0, $6594c97b430a236e$export$180605366c04f0cd)().filtering.services, service.serviceKey);
                $service.innerHTML = `
                    <button class="button">
                    <div class='iconService iconService__${service.serviceKey}'></div>
                    <div class='filterList__serviceName'>${(0, $6594c97b430a236e$export$236350842f3cd9bc)((0, $6594c97b430a236e$export$180605366c04f0cd)().filtering.services, service.serviceKey)}</div>
                    <div class="filterList__iconWrapper"></div>
                    </button>`;
                $service.addEventListener("click", ()=>{
                    $service.classList.toggle("active");
                    this.updateActiveFilters();
                });
                return $service;
            });
            $listServices.replaceChildren(...servicesHTML);
            this.$target.appendChild($listServices);
        }
    }
    toggleActive() {
        this.$element.classList.toggle("active");
        const content = this.$element.nextElementSibling;
        if ((content === null || content === void 0 ? void 0 : content.style.maxHeight) && (content === null || content === void 0 ? void 0 : content.style.maxHeight) != "0px") content.style.maxHeight = "0px";
        else content.style.maxHeight = content.scrollHeight + "px";
    }
    updateActiveFilters() {
        const filters = [];
        const filterElements = document.querySelectorAll(".filterList .active");
        filterElements.forEach(($filterLI)=>{
            if ($filterLI.dataset && $filterLI.dataset.servicekey) filters.push($filterLI.dataset.servicekey);
        });
        const queryString = filters.map((serviceKey)=>`tag:${serviceKey}`).join(" and ");
        this.setState({
            activeFilters: filters
        }, true, ()=>this.emit("filters_updated", queryString));
    }
}





var $e67af3c4fd5a5d27$export$5685af560c13eb53;
(function(TravelModeComponentEvents) {
    TravelModeComponentEvents["TRAVEL_MODE_CHANGED"] = "travel_mode_changed";
})($e67af3c4fd5a5d27$export$5685af560c13eb53 || ($e67af3c4fd5a5d27$export$5685af560c13eb53 = {}));
class $e67af3c4fd5a5d27$export$2e2bcd8739ae039 extends (0, $5c07417a90a15ad5$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$element.className = "travelModeSelector";
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) {
            const travelModesHTML = (0, $d0a7dfeff55f6162$export$44487a86467333c3)().directions.travelModes.map((travelMode)=>{
                const $travelMode = document.createElement("div");
                $travelMode.dataset.mode = travelMode.modeKey;
                $travelMode.className = travelMode.modeKey === this.state.selectedTravelMode ? "travelMode travelMode__selected" : "travelMode";
                $travelMode.innerHTML = `
                                <button role="radio">
                                <img alt="${travelMode.modeKey}" class="iconTravelMode iconTravelMode__${travelMode.modeKey}"
                                     src="${travelMode.defaultIcon}"/>
                                <img alt="${travelMode.modeKey}" class="iconTravelMode iconTravelMode__${travelMode.modeKey}__selected"
                                     src="${travelMode.selectedIcon}"/>
                                </button>`;
                $travelMode.addEventListener("click", ()=>{
                    if ($travelMode.dataset && $travelMode.dataset.mode) this.toggleTravelMode($travelMode);
                });
                return $travelMode;
            });
            this.$element.replaceChildren(...travelModesHTML);
        }
    }
    toggleTravelMode($travelMode) {
        this.setState({
            selectedTravelMode: $travelMode.dataset.mode
        }, true, ()=>{
            document.querySelectorAll(".travelMode").forEach((el)=>el.classList.remove("travelMode__selected"));
            $travelMode.classList.add("travelMode__selected");
            this.emit("travel_mode_changed", this.state.selectedTravelMode);
        });
    }
}






var $5932f0076c69b64b$exports = {};

$5932f0076c69b64b$exports = (parcelRequire("1epfE")).getBundleURL("eaJHN") + "loader.40e04524.svg";




var $f0da568a75e9dbda$export$ebf4dc7348200b05;
(function(RoutesSummaryComponentEvents) {
    RoutesSummaryComponentEvents["ROUTE_INDEX_CHANGED"] = "route_index_changed";
    RoutesSummaryComponentEvents["ROADBOOK_SHOW"] = "roadbook_show";
})($f0da568a75e9dbda$export$ebf4dc7348200b05 || ($f0da568a75e9dbda$export$ebf4dc7348200b05 = {}));
class $f0da568a75e9dbda$export$2e2bcd8739ae039 extends (0, $5c07417a90a15ad5$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$element.className = "routesSummary";
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) {
            if (this.state.isLoading) this.setLoading();
            else if (this.state.routes && this.state.routes.length) {
                const routesSummary = this.state.routes.map((route, index)=>{
                    const summary = `${route.legs[0].start_address}`;
                    const duration = `${route.legs[0].duration.text}`;
                    const distance = `${route.legs[0].distance.text}`;
                    const travelModeIcon = (0, $d0a7dfeff55f6162$export$44487a86467333c3)().directions.travelModes.filter(({ modeKey: modeKey })=>modeKey === this.state.travelMode)[0].darkIcon;
                    const $routeSummary = document.createElement("div");
                    $routeSummary.className = index === this.state.selectedRouteIndex ? "directionTrip directionTrip__selected" : "directionTrip";
                    $routeSummary.dataset.index = index.toString();
                    $routeSummary.innerHTML = `
                        <img alt="${this.state.travelMode}" src="${travelModeIcon}" class="directionTrip__travelModeIcon">
                        <div class="directionTrip__description">
                            <div class="directionTrip__numbers">
                                <div class="directionTrip__duration">${duration}</div>
                                <div class="directionTrip__distance"> ${distance}</div>
                            </div>
                            <div>
                                <div class="directionTrip__title">${(0, $6594c97b430a236e$export$180605366c04f0cd)().directions.messages.via} ${summary}</div>
                                <div class="directionTrip__summary">
                                    <div >${duration} ${(0, $6594c97b430a236e$export$180605366c04f0cd)().directions.messages.withoutTraffic}</div>
                                </div>
                            </div>
                            <div class="directionTrip__detailsMsg" data-detailsindex="{{ rendererIndex }}">${(0, $6594c97b430a236e$export$180605366c04f0cd)().directions.messages.details}</div>
                        </div>`;
                    $routeSummary.addEventListener("click", ()=>{
                        if ($routeSummary.dataset && $routeSummary.dataset.index) {
                            const routeIndex = Number($routeSummary.dataset.index);
                            if (routeIndex === this.state.selectedRouteIndex) this.emit("roadbook_show");
                            else this.selectRoute(routeIndex);
                        }
                    });
                    return $routeSummary;
                });
                this.$element.replaceChildren(...routesSummary);
            } else this.setEmptyResults();
        }
    }
    setEmptyResults() {
        let messageBody;
        const $emptyResult = document.createElement("div");
        messageBody = (0, $6594c97b430a236e$export$180605366c04f0cd)().directions.messages.initialBody;
        if (this.state.origin && this.state.destination) messageBody = `${(0, $6594c97b430a236e$export$180605366c04f0cd)().directions.messages.error} 
                            ${(0, $6594c97b430a236e$export$180605366c04f0cd)().directions.messages.from} "<strong>${this.state.origin}</strong>" 
                            ${(0, $6594c97b430a236e$export$180605366c04f0cd)().directions.messages.to} "<strong>${this.state.destination}</strong>" 
                            ${(0, $6594c97b430a236e$export$180605366c04f0cd)().directions.messages.forTravelMode} <strong>${this.state.travelMode}</strong>`;
        if (this.state.error) messageBody += `<div class="directionTrip__error">${this.state.error}</div>`;
        $emptyResult.innerHTML = `
                    <div class="directionTrip__empty">
                    <div>${messageBody}</div>
                    <div>`;
        this.$element.replaceChildren($emptyResult);
    }
    setLoading() {
        const $loader = document.createElement("div");
        $loader.id = "loader";
        $loader.innerHTML = `<img alt="loading..." src=${0, (/*@__PURE__*/$parcel$interopDefault($5932f0076c69b64b$exports))}>`;
        this.$element.replaceChildren($loader);
    }
    selectRoute(routeIndex) {
        this.setState({
            selectedRouteIndex: routeIndex
        }, true, ()=>{
            const $routeSummary = this.$element.querySelector(`[data-index="${this.state.selectedRouteIndex}"]`);
            document.querySelectorAll(".directionTrip").forEach((el)=>el.classList.remove("directionTrip__selected"));
            $routeSummary.classList.add("directionTrip__selected");
            this.emit("route_index_changed", this.state.selectedRouteIndex);
        });
    }
}





var $6535ab12347f78f8$export$da1f36ab6d8337bc;
(function(RouteRoadbookComponentEvents) {
    RouteRoadbookComponentEvents["BACK"] = "back";
})($6535ab12347f78f8$export$da1f36ab6d8337bc || ($6535ab12347f78f8$export$da1f36ab6d8337bc = {}));
class $6535ab12347f78f8$export$2e2bcd8739ae039 extends (0, $5c07417a90a15ad5$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$element.className = "routeRoadbook";
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) {
            const originText = `${this.state.route.legs[0].start_address}`;
            const destinationText = `${this.state.route.legs[0].end_address}`;
            const duration = `${this.state.route.legs[0].duration.text}`;
            const distance = `${this.state.route.legs[0].distance.text}`;
            const directionLink = this.getDirectionGoogleMapsUrl(this.state.route.legs[0].end_location);
            const $roadbookHeader = document.createElement("div");
            $roadbookHeader.className = "routeRoadbook__header";
            $roadbookHeader.innerHTML = `
                                <span class="routeRoadbook__headerFromTo">
                                    <div class="routeRoadbook__headerWaypoint"> ${(0, $6594c97b430a236e$export$180605366c04f0cd)().directions.messages.from} <span class="routeRoadbook__headerFrom">${originText}</span></div>
                                    <div class="routeRoadbook__headerWaypoint"> ${(0, $6594c97b430a236e$export$180605366c04f0cd)().directions.messages.to} <span class="routeRoadbook__headerTo">${destinationText}</span></div>
                                </span>`;
            const $roadbookBody = document.createElement("div");
            $roadbookBody.className = "routeRoadbook__body";
            $roadbookBody.innerHTML = `
                                <div class="routeRoadbook__actions">
                                    <a href="${directionLink}" target="_blank" title="${(0, $6594c97b430a236e$export$180605366c04f0cd)().directions.messages.openGoogleMaps}"><button class="routeRoadbook__actionsButton"></button></a>
                                </div>
                                <div class="routeRoadbook__summaryHeader">
                                  <span>
                                    <span class="delay" >${duration} </span>
                                    <span class="routeRoadbook__summarySubtitle">(<span >${distance}</span>)</span>
                                  </span>
                                  <span class="routeRoadbook__summaryDescription">${(0, $6594c97b430a236e$export$180605366c04f0cd)().directions.messages.via} ${originText}</span>
                                </div>`;
            const $backBtn = document.createElement("button");
            $backBtn.className = "routeRoadbook__headerBack";
            $backBtn.addEventListener("click", ()=>this.emit("back"));
            $roadbookHeader.prepend($backBtn);
            $roadbookBody.appendChild(this.getHTMLInstructions());
            this.$element.replaceChildren(...[
                $roadbookHeader,
                $roadbookBody
            ]);
            this.styleOnScroll($roadbookBody);
        }
    }
    getDirectionGoogleMapsUrl(latlng) {
        return `https://www.google.fr/maps/dir//${latlng.lat},${latlng.lng}`;
    }
    getDirectionStepIcon(action) {
        if (action) {
            const stepIconObj = (0, $d0a7dfeff55f6162$export$44487a86467333c3)().directions.stepsIcon.filter(({ index: index })=>index === action)[0];
            if (stepIconObj) {
                const className = stepIconObj.key.endsWith("Right") ? "reverse" : "";
                return `<div class="routeRoadbook__stepIcon routeRoadbook__stepIcon${className}">
                            <img alt="${stepIconObj.key}" src="${stepIconObj.icon}">
                        </div>`;
            } else return `<div class="routeRoadbook__stepIcon routeRoadbook__stepIcon${action}"></div>`;
        }
        return "";
    }
    getDirectionInstructionStep(instructions) {
        if (instructions) {
            if (instructions.summary) return `<div class="routeRoadbook__stepBody">
                            <span>${instructions.summary}</span>
                        </div>`;
        }
        return "";
    }
    getDirectionInstructionDistance(distance) {
        const $distanceSeperator = document.createElement("div");
        if (distance) {
            $distanceSeperator.className = "routeRoadbook__stepDistance";
            $distanceSeperator.innerHTML = `<div class="routeRoadbook__stepDistanceSeparator"></div>
                    <div class="routeRoadbook__stepDistanceText">${distance}</div>`;
        }
        return $distanceSeperator;
    }
    getWaypoint(address) {
        const $waypoint = document.createElement("div");
        $waypoint.className = "routeRoadbook__waypoint";
        $waypoint.innerHTML = `<span><h4 class="routeRoadbook__waypointAddress">${address}</h4></span>`;
        return $waypoint;
    }
    getHTMLInstructions() {
        const $instructions = document.createElement("div");
        $instructions.className = "routeRoadbook__steps";
        if (this.state.route.legs[0].steps) {
            const $instructionsSteps = this.state.route.legs[0].steps.map((step)=>{
                const $step = document.createElement("div");
                const iconStep = this.getDirectionStepIcon(step.instructions.action);
                const instructionStep = this.getDirectionInstructionStep(step.instructions);
                const $distanceStep = this.getDirectionInstructionDistance(step.distance);
                $step.innerHTML = `<div class="routeRoadbook__step">${iconStep}${instructionStep}</div>`;
                $step.appendChild($distanceStep);
                return $step;
            });
            $instructionsSteps.unshift(this.getWaypoint(this.state.route.legs[0].start_address));
            $instructionsSteps.push(this.getWaypoint(this.state.route.legs[0].end_address));
            $instructions.replaceChildren(...$instructionsSteps);
        }
        return $instructions;
    }
    styleOnScroll($roadbookBody) {
        $roadbookBody === null || $roadbookBody === void 0 ? void 0 : $roadbookBody.addEventListener("scroll", ()=>{
            const scroll = $roadbookBody.scrollTop;
            if (scroll > 0) $roadbookBody.classList.add("active");
            else $roadbookBody.classList.remove("active");
        });
    }
}





var $7c72643d6805cfcb$export$61b319a33691e777;
(function(DirectionsOptionsComponentEvents) {
    DirectionsOptionsComponentEvents["AVOID_UPDATED"] = "avoid_updated";
    DirectionsOptionsComponentEvents["UNIT_UPDATED"] = "unit_updated";
})($7c72643d6805cfcb$export$61b319a33691e777 || ($7c72643d6805cfcb$export$61b319a33691e777 = {}));
class $7c72643d6805cfcb$export$2e2bcd8739ae039 extends (0, $5c07417a90a15ad5$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$element.className = "directionsOptionsHeader collapsible";
        this.$element.innerHTML = `<span class="collapsibleTitle">${(0, $6594c97b430a236e$export$180605366c04f0cd)().directions.options}</span><div class="collapsibleIcon"></div>`;
        this.$element.addEventListener("click", ()=>this.toggleActive());
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) {
            const $avoidOptionsContainer = document.createElement("div");
            $avoidOptionsContainer.className = "directionsOptions__list";
            const $avoidOptionsContent = document.createElement("div");
            $avoidOptionsContent.className = "directionsOptions__content";
            $avoidOptionsContent.innerHTML = `<span class='directionsOptions__header'>${(0, $6594c97b430a236e$export$180605366c04f0cd)().directions.avoid}</span>`;
            const $avoidOptions = (0, $d0a7dfeff55f6162$export$44487a86467333c3)().directions.avoidOptions.map((avoidOption)=>{
                const $avoidInput = document.createElement("div");
                $avoidInput.className = "directionsOptions__input";
                const checked = (0, $d0a7dfeff55f6162$export$44487a86467333c3)().directions.directionsOptions.avoid.includes(avoidOption.paramKey) ? "checked" : "";
                $avoidInput.innerHTML = `
                    <input id="avoid${(0, $6594c97b430a236e$export$236350842f3cd9bc)((0, $6594c97b430a236e$export$180605366c04f0cd)().directions.avoidOptions, avoidOption.paramKey)}" aria-label="Avoid ${avoidOption.paramKey}" name="avoidParams" type="checkbox" 
                           value="${avoidOption.paramKey}" ${checked}>
                    <label for="avoid${(0, $6594c97b430a236e$export$236350842f3cd9bc)((0, $6594c97b430a236e$export$180605366c04f0cd)().directions.avoidOptions, avoidOption.paramKey)}">${(0, $6594c97b430a236e$export$236350842f3cd9bc)((0, $6594c97b430a236e$export$180605366c04f0cd)().directions.avoidOptions, avoidOption.paramKey)}</label>`;
                $avoidInput.addEventListener("click", (event)=>{
                    if (event.target.nodeName === "INPUT") this.updateAvoidPreferences();
                });
                return $avoidInput;
            });
            $avoidOptionsContent.append(...$avoidOptions);
            $avoidOptionsContainer.replaceChildren($avoidOptionsContent);
            const $unitOptionsContainer = document.createElement("div");
            $unitOptionsContainer.className = "directionsOptions__list";
            const $unitOptionsContent = document.createElement("div");
            $unitOptionsContent.className = "directionsOptions__content";
            $unitOptionsContent.innerHTML = `<span class='directionsOptions__header'>${(0, $6594c97b430a236e$export$180605366c04f0cd)().directions.units}</span>`;
            const $unitOptions = (0, $d0a7dfeff55f6162$export$44487a86467333c3)().directions.unitOptions.map((unitOption)=>{
                const $unitInput = document.createElement("div");
                $unitInput.className = "directionsOptions__input";
                const checked = unitOption.paramKey === (0, $d0a7dfeff55f6162$export$44487a86467333c3)().directions.directionsOptions.unitSystem ? "checked" : "";
                $unitInput.innerHTML = `
                    <input id="unit${(0, $6594c97b430a236e$export$236350842f3cd9bc)((0, $6594c97b430a236e$export$180605366c04f0cd)().directions.unitOptions, unitOption.paramKey)}" aria-label="Unit ${unitOption.paramKey}" name="distanceUnits" type="radio" 
                           value="${unitOption.paramKey}" ${checked}>
                    <label for="unit${(0, $6594c97b430a236e$export$236350842f3cd9bc)((0, $6594c97b430a236e$export$180605366c04f0cd)().directions.unitOptions, unitOption.paramKey)}">${(0, $6594c97b430a236e$export$236350842f3cd9bc)((0, $6594c97b430a236e$export$180605366c04f0cd)().directions.unitOptions, unitOption.paramKey)}</label>`;
                $unitInput.addEventListener("click", (event)=>{
                    if (event.target.nodeName === "INPUT") this.changeDistanceUnits();
                });
                return $unitInput;
            });
            $unitOptionsContent.append(...$unitOptions);
            $unitOptionsContainer.replaceChildren($unitOptionsContent);
            const $listOptions = document.createElement("div");
            $listOptions.className = "directionsOptions collapsibleContent";
            $listOptions.replaceChildren(...[
                $avoidOptionsContainer,
                $unitOptionsContainer
            ]);
            this.$target.appendChild($listOptions);
        }
    }
    toggleActive() {
        this.$element.classList.toggle("active");
        const content = this.$element.nextElementSibling;
        if ((content === null || content === void 0 ? void 0 : content.style.maxHeight) && (content === null || content === void 0 ? void 0 : content.style.maxHeight) != "0px") content.style.maxHeight = "0px";
        else content.style.maxHeight = content.scrollHeight + "px";
    }
    updateAvoidPreferences() {
        const avoids = [];
        const optionsElements = document.querySelectorAll('input[name="avoidParams"]:checked');
        optionsElements.forEach(($avoidCheckbox)=>{
            avoids.push($avoidCheckbox.value);
        });
        this.setState({
            avoidOptions: avoids
        }, true, ()=>this.emit("avoid_updated", avoids));
    }
    changeDistanceUnits() {
        const distanceUnit = document.querySelector('input[name="distanceUnits"]:checked').value;
        this.setState({
            distanceUnit: distanceUnit
        }, true, ()=>this.emit("unit_updated", distanceUnit));
    }
}



var $d79cb7225149ae37$export$a7fa205fa3fad685;
(function(DirectionsComponentEvents) {
    DirectionsComponentEvents["MAP_READY"] = "map_ready";
    DirectionsComponentEvents["DIRECTIONS_SHOW"] = "directions_show";
    DirectionsComponentEvents["DESTINATION_CHANGED"] = "destination_changed";
    DirectionsComponentEvents["ROUTES_CHANGED"] = "routes_changed";
    DirectionsComponentEvents["SELECTED_ROUTE_CHANGED"] = "selected_route_changed";
    DirectionsComponentEvents["CLOSE_DIRECTIONS"] = "close_directions";
    DirectionsComponentEvents["ROADBOOK_SHOW"] = "roadbook_show";
    DirectionsComponentEvents["DIRECTIONS_UPDATED"] = "directions_updated";
})($d79cb7225149ae37$export$a7fa205fa3fad685 || ($d79cb7225149ae37$export$a7fa205fa3fad685 = {}));
class $d79cb7225149ae37$export$2e2bcd8739ae039 extends (0, $5c07417a90a15ad5$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$target.appendChild(this.$element);
        this.api = new (0, $91b6a6d3a7626477$export$e91aad2e7ca3cca3)({
            apiKey: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().map.woosmapPublicKey
        });
    }
    render() {
        if (this.state && this.$element) {
            var _this_state_origin, _this_state_destination;
            this.$element.innerHTML = "";
            this.$target.insertAdjacentHTML("afterbegin", this.getHTMLSkeleton());
            const $closeBtn = document.createElement("button");
            $closeBtn.className = "closeDirections";
            $closeBtn.addEventListener("click", ()=>{
                this.emit("close_directions");
            });
            document.getElementById("directionsHeader").append($closeBtn);
            const travelModesComponent = new (0, $e67af3c4fd5a5d27$export$2e2bcd8739ae039)({
                $target: document.getElementById((0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.travelModeContainerID),
                initialState: {
                    selectedTravelMode: this.state.travelMode
                }
            });
            const searchOriginComponent = new (0, $6764db29c49c590e$export$2e2bcd8739ae039)({
                $target: document.getElementById("directionsOrigin"),
                initialState: {
                    inputID: "originInput",
                    woosmapPublicKey: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().map.woosmapPublicKey,
                    searchOptions: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().search.localitiesConf,
                    featuresBtn: [
                        "geolocate",
                        "clear"
                    ]
                }
            });
            const searchDestinationComponent = new (0, $6764db29c49c590e$export$2e2bcd8739ae039)({
                $target: document.getElementById("directionsDestination"),
                initialState: {
                    inputID: "destinationInput",
                    woosmapPublicKey: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().map.woosmapPublicKey,
                    searchOptions: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().search.localitiesConf,
                    featuresBtn: [
                        "clear"
                    ]
                }
            });
            const directionsOptionsComponent = new (0, $7c72643d6805cfcb$export$2e2bcd8739ae039)({
                $target: document.getElementById("directionsOptionsContainer"),
                initialState: {}
            });
            this.routesSummaryComponent = new (0, $f0da568a75e9dbda$export$2e2bcd8739ae039)({
                $target: document.getElementById("directionsRoutesContainer"),
                initialState: {
                    routes: [],
                    travelMode: this.state.travelMode,
                    selectedRouteIndex: 0,
                    avoid: this.state.avoid,
                    unitSystem: this.state.unitSystem,
                    isLoading: false
                }
            });
            if ((_this_state_origin = this.state.origin) === null || _this_state_origin === void 0 ? void 0 : _this_state_origin.name) searchOriginComponent.setLocality(this.state.origin.name);
            if ((_this_state_destination = this.state.destination) === null || _this_state_destination === void 0 ? void 0 : _this_state_destination.name) searchDestinationComponent.setLocality(this.state.destination.name);
            directionsOptionsComponent.on((0, $7c72643d6805cfcb$export$61b319a33691e777).AVOID_UPDATED, (options)=>{
                this.setState({
                    avoid: options
                }, true, ()=>{
                    this.computeRoute();
                });
            });
            directionsOptionsComponent.on((0, $7c72643d6805cfcb$export$61b319a33691e777).UNIT_UPDATED, (unit)=>{
                this.setState({
                    unitSystem: unit
                }, true, ()=>{
                    this.computeRoute();
                });
            });
            searchOriginComponent.on((0, $6764db29c49c590e$export$bec4f8eff0df0668).SELECTED_LOCALITY, (locality)=>{
                this.setState({
                    origin: {
                        location: locality.location,
                        publicId: locality.publicId,
                        name: locality.name
                    }
                }, true, ()=>{
                    if (!this.state.destination) document.getElementById("destinationInput").focus();
                    this.computeRoute();
                });
            });
            searchDestinationComponent.on((0, $6764db29c49c590e$export$bec4f8eff0df0668).SELECTED_LOCALITY, (locality)=>{
                this.setState({
                    destination: {
                        location: locality.location,
                        publicId: locality.publicId,
                        name: locality.name
                    }
                }, true, ()=>{
                    if (!this.state.origin) document.getElementById("originInput").focus();
                    this.computeRoute();
                });
            });
            searchOriginComponent.on((0, $6764db29c49c590e$export$bec4f8eff0df0668).SEARCH_CLEAR, ()=>{
                this.setState({
                    origin: undefined
                }, true, ()=>{
                    this.cleanRoutes();
                });
            });
            searchDestinationComponent.on((0, $6764db29c49c590e$export$bec4f8eff0df0668).SEARCH_CLEAR, ()=>{
                this.setState({
                    destination: undefined
                }, true, ()=>{
                    this.cleanRoutes();
                });
            });
            travelModesComponent.on((0, $e67af3c4fd5a5d27$export$5685af560c13eb53).TRAVEL_MODE_CHANGED, (travelModeKey)=>{
                this.setState({
                    travelMode: travelModeKey
                }, true, ()=>{
                    this.computeRoute();
                });
            });
            this.on("map_ready", (map)=>{
                this.map = map;
                this.initDirectionRenderer();
            });
            this.on("destination_changed", ()=>{
                var _this_state_origin, _this_state_destination;
                if (this.state.origin && this.state.destination) this.computeRoute();
                if ((_this_state_origin = this.state.origin) === null || _this_state_origin === void 0 ? void 0 : _this_state_origin.name) searchOriginComponent.setLocality(this.state.origin.name);
                if ((_this_state_destination = this.state.destination) === null || _this_state_destination === void 0 ? void 0 : _this_state_destination.name) searchDestinationComponent.setLocality(this.state.destination.name);
                this.emit("directions_updated", this.state);
            });
            this.on("directions_show", ()=>{
                var _this_state_directionsResult_routes, _this_state_directionsResult;
                if ((_this_state_directionsResult = this.state.directionsResult) === null || _this_state_directionsResult === void 0 ? void 0 : (_this_state_directionsResult_routes = _this_state_directionsResult.routes) === null || _this_state_directionsResult_routes === void 0 ? void 0 : _this_state_directionsResult_routes.length) {
                    this.directionsRenderer.setMap(this.map);
                    this.directionMarkers.forEach((marker)=>{
                        marker.setMap(this.map);
                    });
                    this.fitToRouteBounds(this.bounds);
                }
                this.emit("directions_updated", this.state);
            });
            let routeRoadbookComponent;
            this.routesSummaryComponent.on((0, $f0da568a75e9dbda$export$ebf4dc7348200b05).ROADBOOK_SHOW, ()=>{
                if (this.state.directionsResult) {
                    if (!routeRoadbookComponent) {
                        routeRoadbookComponent = new (0, $6535ab12347f78f8$export$2e2bcd8739ae039)({
                            $target: document.getElementById((0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.roadbookContainerID),
                            initialState: {
                                route: this.state.directionsResult.routes[this.state.selectedRouteIndex]
                            }
                        });
                        routeRoadbookComponent.on((0, $6535ab12347f78f8$export$da1f36ab6d8337bc).BACK, ()=>{
                            this.emit("directions_show");
                        });
                    } else routeRoadbookComponent.setState({
                        route: this.state.directionsResult.routes[this.state.selectedRouteIndex]
                    });
                }
                this.emit("roadbook_show");
            });
            this.on("routes_changed", ()=>{
                var _this_state_directionsResult, _this_state_origin, _this_state_destination, _this_state_directionsResult1;
                var _this_state_directionsResult_routes, _this_state_origin_name, _this_state_destination_name, _this_state_directionsResult_error_message;
                this.routesSummaryComponent.setState({
                    routes: (_this_state_directionsResult_routes = (_this_state_directionsResult = this.state.directionsResult) === null || _this_state_directionsResult === void 0 ? void 0 : _this_state_directionsResult.routes) !== null && _this_state_directionsResult_routes !== void 0 ? _this_state_directionsResult_routes : [],
                    travelMode: this.state.travelMode,
                    selectedRouteIndex: this.state.selectedRouteIndex,
                    origin: (_this_state_origin_name = (_this_state_origin = this.state.origin) === null || _this_state_origin === void 0 ? void 0 : _this_state_origin.name) !== null && _this_state_origin_name !== void 0 ? _this_state_origin_name : "",
                    destination: (_this_state_destination_name = (_this_state_destination = this.state.destination) === null || _this_state_destination === void 0 ? void 0 : _this_state_destination.name) !== null && _this_state_destination_name !== void 0 ? _this_state_destination_name : "",
                    avoid: this.state.avoid,
                    unitSystem: this.state.unitSystem,
                    error: (_this_state_directionsResult_error_message = (_this_state_directionsResult1 = this.state.directionsResult) === null || _this_state_directionsResult1 === void 0 ? void 0 : _this_state_directionsResult1.error_message) !== null && _this_state_directionsResult_error_message !== void 0 ? _this_state_directionsResult_error_message : "",
                    isLoading: false
                });
                this.emit("directions_show");
                this.emit("directions_updated", this.state);
            });
            this.on("selected_route_changed", ()=>{
                this.routesSummaryComponent.selectRoute(this.state.selectedRouteIndex);
                if (this.state.directionsResult && routeRoadbookComponent) routeRoadbookComponent.setState({
                    route: this.state.directionsResult.routes[this.state.selectedRouteIndex]
                });
            });
            this.routesSummaryComponent.on((0, $f0da568a75e9dbda$export$ebf4dc7348200b05).ROUTE_INDEX_CHANGED, (selectedRouteIndex)=>{
                this.setState({
                    selectedRouteIndex: selectedRouteIndex
                }, true, ()=>{
                    this.directionsRenderer.setRouteIndex(this.state.selectedRouteIndex);
                });
            });
            this.on("close_directions", ()=>{
                this.cleanRoutes(true);
            });
        }
    }
    initDirectionRenderer() {
        this.directionsRenderer = new woosmap.map.DirectionsRenderer({
            preserveViewport: true
        });
        this.directionsRenderer.addListener("routeIndex_changed", ()=>{
            this.setState({
                selectedRouteIndex: this.directionsRenderer.get("routeIndex")
            }, true, ()=>{
                this.emit("selected_route_changed");
            });
        });
        this.computeRoute();
    }
    computeRoute() {
        if (this.state.origin && this.state.destination) {
            var _this_state_origin, _this_state_destination;
            this.routesSummaryComponent.setState({
                isLoading: true
            });
            this.api.distance.route({
                origin: ((_this_state_origin = this.state.origin) === null || _this_state_origin === void 0 ? void 0 : _this_state_origin.location) ? `${this.state.origin.location.lat},${this.state.origin.location.lng}` : "",
                destination: ((_this_state_destination = this.state.destination) === null || _this_state_destination === void 0 ? void 0 : _this_state_destination.location) ? `${this.state.destination.location.lat},${this.state.destination.location.lng}` : "",
                mode: this.state.travelMode,
                units: this.state.unitSystem,
                alternatives: this.state.provideRouteAlternatives,
                avoid: this.state.avoid.join("|"),
                details: "full"
            }).then((response)=>{
                this.setState({
                    directionsResult: response,
                    selectedRouteIndex: 0
                }, true, ()=>{
                    this.updateRoutes();
                });
            }).catch((exception)=>{
                console.error(exception);
                this.setState({
                    directionsResult: {
                        routes: []
                    },
                    selectedRouteIndex: 0
                }, true);
                this.cleanRoutes();
            }).finally(()=>{
                this.emit("routes_changed");
            });
        }
    }
    cleanRoutes(preserveMarkers) {
        this.directionsRenderer.setMap(null);
        this.removeMarkers();
        if (!preserveMarkers) this.directionMarkers = [];
    }
    updateRoutes() {
        var _this_state_directionsResult_routes, _this_state_directionsResult;
        if ((_this_state_directionsResult = this.state.directionsResult) === null || _this_state_directionsResult === void 0 ? void 0 : (_this_state_directionsResult_routes = _this_state_directionsResult.routes) === null || _this_state_directionsResult_routes === void 0 ? void 0 : _this_state_directionsResult_routes.length) {
            var _this_state_origin, _this_state_destination;
            this.cleanRoutes();
            this.bounds = new woosmap.map.LatLngBounds();
            for (const element of this.state.directionsResult.routes){
                const route = element;
                this.bounds.union(new woosmap.map.LatLngBounds(route.bounds.northeast, route.bounds.southwest));
                if (route.overview_polyline) {
                    const encodedPolyline = route.overview_polyline;
                    const decodedPolyline = (0, $d1947f3ca833a885$export$b89605802fcf91d2)(encodedPolyline.points);
                    route.overview_path = decodedPolyline.map((latlng)=>new woosmap.map.LatLng(latlng[0], latlng[1]));
                }
            }
            this.directionsRenderer.setDirections(this.state.directionsResult);
            this.directionsRenderer.setMap(this.map);
            this.fitToRouteBounds(this.bounds);
            if (((_this_state_origin = this.state.origin) === null || _this_state_origin === void 0 ? void 0 : _this_state_origin.location) && ((_this_state_destination = this.state.destination) === null || _this_state_destination === void 0 ? void 0 : _this_state_destination.location)) {
                var _this_state_origin_name;
                this.addMarkerLabel(this.state.origin.location, (0, $d0a7dfeff55f6162$export$44487a86467333c3)().directions.iconsDirections.start, (_this_state_origin_name = this.state.origin.name) !== null && _this_state_origin_name !== void 0 ? _this_state_origin_name : "");
                var _this_state_destination_name;
                this.addMarkerLabel(this.state.destination.location, (0, $d0a7dfeff55f6162$export$44487a86467333c3)().directions.iconsDirections.end, (_this_state_destination_name = this.state.destination.name) !== null && _this_state_destination_name !== void 0 ? _this_state_destination_name : "");
            }
        } else this.cleanRoutes();
    }
    removeMarkers() {
        this.directionMarkers.forEach((marker)=>{
            marker.setMap(null);
        });
    }
    addMarkerLabel(positon, icon, label) {
        const iconWidth = icon.scaledSize.width;
        icon.labelOrigin = new woosmap.map.Point(Math.ceil((0, $d1947f3ca833a885$export$37827d046293d309)(label) / 2 + iconWidth + 2), Math.round(iconWidth / 2));
        this.directionMarkers.push(new woosmap.map.Marker({
            label: {
                text: label,
                className: "markerLabel"
            },
            position: positon,
            icon: icon,
            map: this.map
        }));
    }
    fitToRouteBounds(bounds) {
        this.map.fitBounds(bounds, this.state.padding);
    }
    getHTMLSkeleton() {
        return `
        <div id="directionsInputs">
            <div id="directionsHeader">
                <div id="${(0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.travelModeContainerID}"></div>
            </div>
            <div id="odInputs">
                <div>
                    <div id="directionsOrigin">
                    </div>
                    <div id="directionsDestination">
                    </div>
                </div>
            </div>
        </div>
        <div id="directionsOptionsContainer"></div>
        <div id="directionsResults">
            <div id="directionsOptions"></div>
            <div id="directionsRoutesContainer"></div>
        </div>`;
    }
    constructor(...args){
        super(...args);
        this.directionMarkers = [];
    }
}





// Regular expressions for parsing URL parameters
const $b78a2ee9fd7f6575$var$LOCATION_REGEX = /@([-\d.]+),([-\d.]+),(\d+)/;
const $b78a2ee9fd7f6575$var$DIRECTION_REGEX = /\/direction\/([^/]*)\/([-\d.]*)?,?([-\d.]*)?\/([^/]*)\/([-\d.]+),([-\d.]+)/;
const $b78a2ee9fd7f6575$var$STORE_ID_REGEX = /\/store\/(.+?)\//;
const $b78a2ee9fd7f6575$var$LOCALITY_SEARCH_TEXT_REGEX = /\/search\/(.+?)\//;
const $b78a2ee9fd7f6575$var$LOCALITY_DATA_REGEX = /loc=!pid(.+?)!lat([-\d.]+)!lng([-\d.]+)/;
class $b78a2ee9fd7f6575$export$1e8e99ed47670682 {
    /**
     * Converts a Base64 string to a hexadecimal string.
     */ static base64ToHex(str) {
        const raw = atob(str);
        let result = "";
        for(let i = 0; i < raw.length; i++){
            const hex = raw.charCodeAt(i).toString(16);
            result += hex.length === 2 ? hex : "0" + hex;
        }
        return result;
    }
    /**
     * Converts a hexadecimal string to a Base64 string.
     */ static hexToBase64(str) {
        let raw = "";
        for(let i = 0; i < str.length; i += 2)raw += String.fromCharCode(parseInt(str.substr(i, 2), 16));
        return btoa(raw);
    }
    /**
     * Loads parameters from the URL.
     */ loadFromURL() {
        // Parse query parameters
        const searchParams = new URLSearchParams(window.location.search);
        this.parameters = {};
        [
            ...searchParams.keys()
        ].forEach((key)=>{
            const value = searchParams.get(key);
            if (value !== null) this.parameters[key] = value;
        });
        // Parse URL path to extract searchText and location
        const path = window.location.pathname;
        this.parseDirection(path);
        this.parseStoreId(path);
        this.parseLocation(path);
        this.parseLocalitySearchText(path);
        this.parseLocalityData(path);
    }
    /**
     * Parses a value from the URL path using a regular expression.
     * @param {string} path - The URL path.
     * @param {RegExp} regex - The regular expression to use.
     * @param {(match: RegExpMatchArray) => void} processMatch - The function to process the match.
     */ parseValueFromPath(path, regex, processMatch) {
        // If the URL contains a hashbang, use location.hash instead of location.pathname
        if (window.location.href.includes("#!")) path = window.location.hash.replace("#!", "");
        const match = regex.exec(path);
        if (match) try {
            processMatch(match);
        } catch (error) {
            console.error(`Error processing match for regex ${regex}: ${error}`);
        }
    }
    /**
     * Parses the location from the URL path.
     * @param {string} path - The URL path.
     */ parseLocation(path) {
        this.parseValueFromPath(path, $b78a2ee9fd7f6575$var$LOCATION_REGEX, (match)=>{
            this.parameters.location = {
                latitude: this.roundToN(match[1], 6),
                longitude: this.roundToN(match[2], 6),
                zoom: this.roundToN(match[3], 2)
            };
        });
    }
    /**
     * Parses the direction from the URL path.
     * @param {string} path - The URL path.
     */ parseDirection(path) {
        this.parseValueFromPath(path, $b78a2ee9fd7f6575$var$DIRECTION_REGEX, (match)=>{
            if (match) {
                var _this_parameters_direction_from, _this_parameters_direction_from1, _this_parameters_direction_to, _this_parameters_direction_to1;
                this.parameters.direction = {
                    from: {
                        name: decodeURIComponent(match[1]) || undefined,
                        location: match[2] ? {
                            lat: parseFloat(match[2]),
                            lng: parseFloat(match[3])
                        } : undefined
                    },
                    to: {
                        name: decodeURIComponent(match[4]) || undefined,
                        location: match[5] ? {
                            lat: parseFloat(match[5]),
                            lng: parseFloat(match[6])
                        } : undefined
                    }
                };
                if (!((_this_parameters_direction_from = this.parameters.direction.from) === null || _this_parameters_direction_from === void 0 ? void 0 : _this_parameters_direction_from.location) && !((_this_parameters_direction_from1 = this.parameters.direction.from) === null || _this_parameters_direction_from1 === void 0 ? void 0 : _this_parameters_direction_from1.name)) this.parameters.direction.from = undefined;
                if (!((_this_parameters_direction_to = this.parameters.direction.to) === null || _this_parameters_direction_to === void 0 ? void 0 : _this_parameters_direction_to.location) && !((_this_parameters_direction_to1 = this.parameters.direction.to) === null || _this_parameters_direction_to1 === void 0 ? void 0 : _this_parameters_direction_to1.name)) this.parameters.direction.to = undefined;
            }
        });
    }
    /**
     * Parses the store ID from the URL path.
     * @param {string} path - The URL path.
     */ parseStoreId(path) {
        this.parseValueFromPath(path, $b78a2ee9fd7f6575$var$STORE_ID_REGEX, (match)=>{
            this.parameters.storeId = decodeURIComponent(match[1]);
        });
    }
    /**
     * Parses the locality searchText from the URL path.
     * @param {string} path - The URL path.
     */ parseLocalitySearchText(path) {
        this.parseValueFromPath(path, $b78a2ee9fd7f6575$var$LOCALITY_SEARCH_TEXT_REGEX, (match)=>{
            if (match) this.parameters.locality = {
                name: decodeURIComponent(match[1]),
                publicId: undefined,
                location: undefined
            };
        });
    }
    /**
     * Parses the locality data from the URL path.
     * @param {string} path - The URL path.
     */ parseLocalityData(path) {
        this.parseValueFromPath(path, $b78a2ee9fd7f6575$var$LOCALITY_DATA_REGEX, (match)=>{
            if (match) {
                if (!this.parameters.locality) this.parameters.locality = {
                    name: undefined,
                    publicId: undefined,
                    location: undefined
                };
                this.parameters.locality.publicId = $b78a2ee9fd7f6575$export$1e8e99ed47670682.hexToBase64(match[1]);
                this.parameters.locality.location = {
                    lat: parseFloat(match[2]),
                    lng: parseFloat(match[3])
                };
            }
        });
    }
    /**
     * Updates the URL with the current parameters.
     */ updateURL() {
        let urlPath = this.baseURL;
        let dataParam = "";
        if (this.parameters.direction) urlPath += this.getDirectionPath();
        else if (this.parameters.storeId) urlPath += this.getStorePath();
        else if (this.parameters.locality) {
            const { localityPath: localityPath, data: data } = this.getLocalityPath();
            urlPath += localityPath;
            dataParam = data;
        }
        if (this.parameters.location) urlPath += this.getLocationPath();
        if (dataParam) urlPath += dataParam;
        window.history.pushState(this.parameters, "", urlPath);
    }
    /**
     * Gets the store path.
     * @private
     */ getStorePath() {
        return `store/${this.parameters.storeId}/`;
    }
    /**
     * Gets the locality path and data param.
     * @private
     */ getLocalityPath() {
        let localityPath = "";
        let data = "";
        if (this.parameters.locality) {
            if (this.parameters.locality.name) localityPath += `search/${encodeURIComponent(this.parameters.locality.name)}/`;
            if (this.parameters.locality.publicId) {
                const pid = $b78a2ee9fd7f6575$export$1e8e99ed47670682.base64ToHex(this.parameters.locality.publicId);
                data = this.parameters.locality.location ? `loc=!pid${pid}!lat${this.parameters.locality.location.lat}!lng${this.parameters.locality.location.lng}/` : `loc=!pid${pid}/`;
            }
        }
        return {
            localityPath: localityPath,
            data: data
        };
    }
    /**
     * Gets the direction path.
     * @private
     */ getDirectionPath() {
        var _this_parameters_direction, _this_parameters_direction1;
        let path = "";
        if (((_this_parameters_direction = this.parameters.direction) === null || _this_parameters_direction === void 0 ? void 0 : _this_parameters_direction.from) || ((_this_parameters_direction1 = this.parameters.direction) === null || _this_parameters_direction1 === void 0 ? void 0 : _this_parameters_direction1.to)) {
            var _this_parameters_direction_from, _this_parameters_direction2, _this_parameters_direction_from1, _this_parameters_direction3, _this_parameters_direction_to, _this_parameters_direction4, _this_parameters_direction_to1, _this_parameters_direction5;
            path += "direction/";
            var _this_parameters_direction_from_name;
            const fromName = (_this_parameters_direction_from_name = (_this_parameters_direction2 = this.parameters.direction) === null || _this_parameters_direction2 === void 0 ? void 0 : (_this_parameters_direction_from = _this_parameters_direction2.from) === null || _this_parameters_direction_from === void 0 ? void 0 : _this_parameters_direction_from.name) !== null && _this_parameters_direction_from_name !== void 0 ? _this_parameters_direction_from_name : "";
            const fromLatLng = ((_this_parameters_direction3 = this.parameters.direction) === null || _this_parameters_direction3 === void 0 ? void 0 : (_this_parameters_direction_from1 = _this_parameters_direction3.from) === null || _this_parameters_direction_from1 === void 0 ? void 0 : _this_parameters_direction_from1.location) ? `${this.parameters.direction.from.location.lat},${this.parameters.direction.from.location.lng}` : "";
            var _this_parameters_direction_to_name;
            const toName = (_this_parameters_direction_to_name = (_this_parameters_direction4 = this.parameters.direction) === null || _this_parameters_direction4 === void 0 ? void 0 : (_this_parameters_direction_to = _this_parameters_direction4.to) === null || _this_parameters_direction_to === void 0 ? void 0 : _this_parameters_direction_to.name) !== null && _this_parameters_direction_to_name !== void 0 ? _this_parameters_direction_to_name : "";
            const toLatLng = ((_this_parameters_direction5 = this.parameters.direction) === null || _this_parameters_direction5 === void 0 ? void 0 : (_this_parameters_direction_to1 = _this_parameters_direction5.to) === null || _this_parameters_direction_to1 === void 0 ? void 0 : _this_parameters_direction_to1.location) ? `${this.parameters.direction.to.location.lat},${this.parameters.direction.to.location.lng}` : "";
            path += `${encodeURIComponent(fromName)}/${fromLatLng}/${encodeURIComponent(toName)}/${toLatLng}/`;
        }
        return path;
    }
    /**
     * Gets the location path.
     * @private
     */ getLocationPath() {
        if (this.parameters.location) return `@${this.parameters.location.latitude},${this.parameters.location.longitude},${this.parameters.location.zoom}/`;
        return "";
    }
    /**
     * Sets a new location in the URL.
     * @param {Location} location - The new location.
     */ setLocation(location) {
        this.parameters.location = {
            latitude: this.roundToN(location.latitude, 6),
            longitude: this.roundToN(location.longitude, 6),
            zoom: this.roundToN(location.zoom, 2)
        };
        this.updateURL();
    }
    /**
     * Returns the location from the URL parameters.
     * @return {Location | undefined} The location, or undefined if no location is set.
     */ getLocation() {
        return this.parameters.location;
    }
    /**
     * Gets the store ID.
     * @returns {string | undefined} The store ID.
     */ getStoreId() {
        return this.parameters.storeId;
    }
    /**
     * Sets a new store ID.
     * @param {string | undefined} storeId - The new store ID.
     */ setStoreId(storeId) {
        this.parameters.storeId = storeId;
        this.updateURL();
    }
    /**
     * Gets the locality.
     * @returns {SearchLocation | undefined} The locality.
     */ getLocality() {
        return this.parameters.locality;
    }
    /**
     * Sets a new locality.
     * @param {SearchLocation | undefined} locality - The new locality.
     */ setLocality(locality) {
        if (locality) this.parameters.locality = {
            name: locality.name,
            publicId: locality.publicId,
            location: locality.location ? {
                lat: this.roundToN(locality.location.lat, 6),
                lng: this.roundToN(locality.location.lng, 6)
            } : undefined
        };
        else this.parameters.locality = undefined;
        this.updateURL();
    }
    /**
     * Gets the direction.
     * @returns {Direction | undefined} The direction.
     */ getDirection() {
        return this.parameters.direction;
    }
    /**
     * Sets a new direction.
     * @param {Direction | undefined} direction - The new direction.
     */ setDirection(direction) {
        if (direction) {
            var _direction_from, _direction_from1, _direction_from2, _direction_from3, _direction_from4, _direction_from5, _direction_to, _direction_to1, _direction_to2, _direction_to3, _direction_to4, _direction_to5;
            const fromLocation = ((_direction_from = direction.from) === null || _direction_from === void 0 ? void 0 : _direction_from.location) ? {
                lat: this.roundToN((_direction_from1 = direction.from) === null || _direction_from1 === void 0 ? void 0 : _direction_from1.location.lat, 6),
                lng: this.roundToN((_direction_from2 = direction.from) === null || _direction_from2 === void 0 ? void 0 : _direction_from2.location.lng, 6)
            } : undefined;
            const fromName = ((_direction_from3 = direction.from) === null || _direction_from3 === void 0 ? void 0 : _direction_from3.name) && ((_direction_from4 = direction.from) === null || _direction_from4 === void 0 ? void 0 : _direction_from4.name) !== "" ? (_direction_from5 = direction.from) === null || _direction_from5 === void 0 ? void 0 : _direction_from5.name : undefined;
            const toLocation = ((_direction_to = direction.to) === null || _direction_to === void 0 ? void 0 : _direction_to.location) ? {
                lat: this.roundToN((_direction_to1 = direction.to) === null || _direction_to1 === void 0 ? void 0 : _direction_to1.location.lat, 6),
                lng: this.roundToN((_direction_to2 = direction.to) === null || _direction_to2 === void 0 ? void 0 : _direction_to2.location.lng, 6)
            } : undefined;
            const toName = ((_direction_to3 = direction.to) === null || _direction_to3 === void 0 ? void 0 : _direction_to3.name) && ((_direction_to4 = direction.to) === null || _direction_to4 === void 0 ? void 0 : _direction_to4.name) !== "" ? (_direction_to5 = direction.to) === null || _direction_to5 === void 0 ? void 0 : _direction_to5.name : undefined;
            this.parameters.direction = {
                from: fromLocation || fromName ? {
                    location: fromLocation,
                    name: fromName
                } : undefined,
                to: toLocation || toName ? {
                    location: toLocation,
                    name: toName
                } : undefined
            };
        } else this.parameters.direction = undefined;
        this.updateURL();
    }
    /**
     * Constructs a new URLParameterManager and loads parameters from the URL.
     */ constructor(){
        this.baseURL = "/storelocator/mapjs/#!/";
        /**
     * Rounds a number to the specified number of decimal places.
     * @param {number} value - The number to round.
     * @param {number} decimals - The number of decimal places.
     * @return {number} The rounded number.
     */ this.roundToN = (value, decimals)=>{
            const num = typeof value === "string" ? parseFloat(value) : value;
            return +(Math.round(Number(num + `e+${decimals}`)) + `e-${decimals}`);
        };
        this.parameters = {};
        this.loadFromURL();
        // Listen for URL changes
        window.addEventListener("popstate", ()=>{
            this.loadFromURL();
        });
    }
}



var $207b26abb5e33c5a$export$489a40757d2e9df5;
(function(StoreLocatorEvents) {
    StoreLocatorEvents["PADDING_CHANGED"] = "padding_changed";
})($207b26abb5e33c5a$export$489a40757d2e9df5 || ($207b26abb5e33c5a$export$489a40757d2e9df5 = {}));
var $207b26abb5e33c5a$export$5ea5b4f66bfb2f2f;
(function(StoreLocatorViews) {
    StoreLocatorViews["DETAILS_VIEW"] = "details_view";
    StoreLocatorViews["LIST_VIEW"] = "list_view";
    StoreLocatorViews["DIRECTIONS_VIEW"] = "directions_view";
    StoreLocatorViews["ROADBOOK_VIEW"] = "roadbook_view";
})($207b26abb5e33c5a$export$5ea5b4f66bfb2f2f || ($207b26abb5e33c5a$export$5ea5b4f66bfb2f2f = {}));
class $207b26abb5e33c5a$export$2e2bcd8739ae039 extends (0, $5c07417a90a15ad5$export$2e2bcd8739ae039) {
    init() {
        this.urlParameterManager = new (0, $b78a2ee9fd7f6575$export$1e8e99ed47670682)();
    }
    render() {
        (0, $6594c97b430a236e$export$e6103b0362967aab)(this.state.locale || (0, $6594c97b430a236e$export$9a2147b3808d4c6b));
        (0, $d0a7dfeff55f6162$export$940a7873bb071df8)(this.state.config);
        this.$target.innerHTML = "";
        this.$target.insertAdjacentHTML("afterbegin", this.getHTMLSkeleton());
        this.$sidebarContentContainer = document.getElementById((0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.sidebarContentContainerID);
        this.styleOnScroll();
        this.searchComponent = new (0, $6764db29c49c590e$export$2e2bcd8739ae039)({
            $target: document.getElementById((0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.searchWrapperID),
            initialState: {
                inputID: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.searchInputID,
                woosmapPublicKey: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().map.woosmapPublicKey,
                searchOptions: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().search.localitiesConf,
                featuresBtn: [
                    "search",
                    "clear",
                    "geolocate"
                ],
                selectedLocality: undefined
            }
        });
        this.mapComponent = new (0, $08b91cdba4d81dbe$export$2e2bcd8739ae039)({
            $target: document.getElementById((0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.mapContainerID),
            initialState: {
                woosmapPublicKey: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().map.woosmapPublicKey,
                mapOptions: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().map.mapOptions,
                storesStyle: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().map.storesStyle,
                padding: this.state.padding,
                location: this.urlParameterManager.getLocation()
            }
        });
        this.directionsComponent = new (0, $d79cb7225149ae37$export$2e2bcd8739ae039)({
            $target: document.getElementById((0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.directionsContainerID),
            initialState: {
                padding: this.state.padding,
                provideRouteAlternatives: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().directions.directionsOptions.provideRouteAlternatives,
                travelMode: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().directions.directionsOptions.travelMode,
                unitSystem: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().directions.directionsOptions.unitSystem,
                avoid: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().directions.directionsOptions.avoid,
                selectedRouteIndex: 0
            }
        });
        this.storesListComponent = new (0, $f0ae777be0abac32$export$2e2bcd8739ae039)({
            $target: document.getElementById((0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.listStoresContainerID),
            initialState: {}
        });
        this.storeDetailsComponent = new (0, $72b71f2c4b6f4878$export$2e2bcd8739ae039)({
            $target: document.getElementById((0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.detailsStoreContainerID),
            initialState: {
                store: undefined
            }
        });
        if ((0, $d0a7dfeff55f6162$export$44487a86467333c3)().search.availableServices.length) {
            this.filterComponent = new (0, $8ad82d7eb9e1a62d$export$2e2bcd8739ae039)({
                $target: document.getElementById((0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.filterPanelContainerID),
                initialState: {}
            });
            this.filterComponent.on((0, $8ad82d7eb9e1a62d$export$f5c69f55b3b1a646).FILTERS_UPDATED, (queryString)=>{
                this.storesListComponent.setState({
                    query: queryString
                }, true, ()=>this.storesListComponent.emit((0, $f0ae777be0abac32$export$e16b04041918aede).QUERY_CHANGED));
                this.mapComponent.setState({
                    query: queryString
                }, true, ()=>this.mapComponent.emit((0, $08b91cdba4d81dbe$export$715fed9478e7c158).FILTERS_UPDATED));
            });
        }
        this.searchComponent.on((0, $6764db29c49c590e$export$bec4f8eff0df0668).SELECTED_LOCALITY, (locality)=>{
            this.urlParameterManager.setLocality(locality);
            this.storeDetailsComponent.setState({
                store: undefined
            });
            this.storesListComponent.setState({
                nearbyLocation: locality.location
            }, true, ()=>this.storesListComponent.emit((0, $f0ae777be0abac32$export$e16b04041918aede).LOCALITY_CHANGED));
            this.directionsComponent.setState({
                origin: {
                    location: locality.location,
                    name: locality.name
                }
            }, true);
            this.setListView();
        });
        this.searchComponent.on((0, $6764db29c49c590e$export$bec4f8eff0df0668).SEARCH_CLEAR, ()=>{
            this.urlParameterManager.setLocality(undefined);
            this.storesListComponent.setState({
                nearbyLocation: undefined,
                stores: []
            });
            this.mapComponent.setState({
                selectedStore: undefined,
                nearbyLocation: undefined,
                stores: []
            }, true, ()=>this.mapComponent.emit((0, $08b91cdba4d81dbe$export$715fed9478e7c158).STORES_CHANGED));
            this.directionsComponent.setState({
                origin: undefined
            }, true);
            this.setListView();
            this.setUserPosition(undefined);
        });
        this.storesListComponent.on((0, $f0ae777be0abac32$export$e16b04041918aede).STORES_CHANGED, ({ stores: stores, nearbyLocation: nearbyLocation })=>{
            this.mapComponent.setState({
                selectedStore: undefined
            }, true);
            this.mapComponent.setState({
                stores: stores,
                nearbyLocation: nearbyLocation
            }, true, ()=>{
                this.mapComponent.emit((0, $08b91cdba4d81dbe$export$715fed9478e7c158).STORES_CHANGED);
                this.setUserPosition(nearbyLocation);
            });
            this.setListView();
        });
        this.storesListComponent.on((0, $f0ae777be0abac32$export$e16b04041918aede).STORE_SELECTED, (selectedStore)=>{
            this.urlParameterManager.setStoreId(selectedStore.properties.store_id);
            this.storeDetailsComponent.setState({
                store: selectedStore
            });
            this.mapComponent.setState({
                selectedStore: selectedStore
            }, true, ()=>this.mapComponent.selectStore());
            this.setDetailsView();
        });
        this.storesListComponent.on((0, $f0ae777be0abac32$export$e16b04041918aede).STORE_MOUSEENTER, (0, $d1947f3ca833a885$export$61fc7d43ac8f84b0)((selectedStore)=>{
            this.mapComponent.selectStoreOnDataOverlay(selectedStore);
        }, 50));
        this.storesListComponent.on((0, $f0ae777be0abac32$export$e16b04041918aede).STORE_MOUSELEAVE, (0, $d1947f3ca833a885$export$61fc7d43ac8f84b0)(()=>{
            if (this.$target.className !== "details_view") this.mapComponent.unselectStoreOnDataOverlay();
        }, 50));
        this.storeDetailsComponent.on((0, $72b71f2c4b6f4878$export$fc087719351cdb12).BACK, ()=>{
            this.mapComponent.setState({
                selectedStore: undefined
            }, true, ()=>this.mapComponent.emit((0, $08b91cdba4d81dbe$export$715fed9478e7c158).STORE_UNSELECTED));
            this.setListView();
        });
        this.mapComponent.on((0, $08b91cdba4d81dbe$export$715fed9478e7c158).MAP_READY, ()=>{
            this.directionsComponent.emit((0, $d79cb7225149ae37$export$a7fa205fa3fad685).MAP_READY, this.mapComponent.map);
            this.setChildrenInitialState();
        });
        this.mapComponent.on((0, $08b91cdba4d81dbe$export$715fed9478e7c158).MAP_IDLE, ()=>{
            this.emit((0, $08b91cdba4d81dbe$export$715fed9478e7c158).MAP_IDLE);
        });
        this.mapComponent.on((0, $08b91cdba4d81dbe$export$715fed9478e7c158).LOCATION_CHANGED, (location)=>{
            this.urlParameterManager.setLocation(location);
        });
        this.mapComponent.on((0, $08b91cdba4d81dbe$export$715fed9478e7c158).STORE_UNSELECTED, ()=>{
            this.urlParameterManager.setStoreId(undefined);
            if (this.$target.className === "details_view") this.setListView();
        });
        this.storeDetailsComponent.on((0, $72b71f2c4b6f4878$export$fc087719351cdb12).DIRECTIONS_SHOW, (selectedStore)=>{
            const destination = {
                name: selectedStore.properties.name,
                location: {
                    lat: selectedStore.geometry.coordinates[1],
                    lng: selectedStore.geometry.coordinates[0]
                }
            };
            if (this.directionsComponent.checkNeedUpdate({
                destination: destination
            })) this.directionsComponent.setState({
                destination: destination
            }, true, ()=>this.directionsComponent.emit((0, $d79cb7225149ae37$export$a7fa205fa3fad685).DESTINATION_CHANGED));
            else this.directionsComponent.emit((0, $d79cb7225149ae37$export$a7fa205fa3fad685).DIRECTIONS_SHOW);
            this.setDirectionsView();
        });
        this.directionsComponent.on((0, $d79cb7225149ae37$export$a7fa205fa3fad685).DIRECTIONS_UPDATED, (directionState)=>{
            this.urlParameterManager.setDirection({
                from: directionState.origin,
                to: directionState.destination
            });
        });
        this.mapComponent.on((0, $08b91cdba4d81dbe$export$715fed9478e7c158).STORE_SELECTED, (selectedStore)=>{
            if (selectedStore) {
                this.urlParameterManager.setStoreId(selectedStore.properties.store_id);
                this.storeDetailsComponent.setState({
                    store: selectedStore
                });
                if (this.$target.className === "directions_view" || this.$target.className === "roadbook_view") {
                    const destination = {
                        name: selectedStore.properties.name,
                        location: {
                            lat: selectedStore.geometry.coordinates[1],
                            lng: selectedStore.geometry.coordinates[0]
                        }
                    };
                    this.directionsComponent.setState({
                        destination: destination
                    }, true, ()=>{
                        this.directionsComponent.emit((0, $d79cb7225149ae37$export$a7fa205fa3fad685).DESTINATION_CHANGED);
                    });
                } else this.setDetailsView();
            } else {
                this.urlParameterManager.setStoreId(undefined);
                this.setDetailsView();
            }
        });
        this.on("padding_changed", ()=>{
            this.directionsComponent.setState({
                padding: this.state.padding
            }, true);
            this.mapComponent.setState({
                padding: this.state.padding
            }, true);
        });
        this.directionsComponent.on((0, $d79cb7225149ae37$export$a7fa205fa3fad685).ROADBOOK_SHOW, ()=>{
            this.setRoadbookView();
        });
        this.directionsComponent.on((0, $d79cb7225149ae37$export$a7fa205fa3fad685).DIRECTIONS_SHOW, ()=>{
            this.setDirectionsView();
        });
        this.directionsComponent.on((0, $d79cb7225149ae37$export$a7fa205fa3fad685).CLOSE_DIRECTIONS, ()=>{
            if (this.urlParameterManager.getDirection()) this.urlParameterManager.setDirection(undefined);
            if (this.urlParameterManager.getStoreId()) this.setDetailsView();
            else this.setListView();
        });
        window.addEventListener("resize", (0, $d1947f3ca833a885$export$61fc7d43ac8f84b0)(()=>{
            this.managePadding();
        }, 100));
        this.managePadding();
    }
    setChildrenInitialState() {
        if (this.urlParameterManager.getStoreId()) {
            const api = new (0, $91b6a6d3a7626477$export$e91aad2e7ca3cca3)({
                apiKey: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().map.woosmapPublicKey
            });
            api.stores.searchStores({
                query: `idstore:="${this.urlParameterManager.getStoreId()}"`
            }).then((response)=>{
                const selectedStore = response === null || response === void 0 ? void 0 : response.features[0];
                this.storeDetailsComponent.setState({
                    store: selectedStore
                });
                this.setDetailsView();
                this.mapComponent.setState({
                    selectedStore: selectedStore
                }, true, ()=>this.mapComponent.selectStore());
            }).catch((exception)=>{
                console.error(exception);
            });
        } else if (this.urlParameterManager.getLocality()) this.searchComponent.setState({
            selectedLocality: this.urlParameterManager.getLocality()
        }, true, ()=>{
            this.searchComponent.selectLocality();
        });
        else if (this.urlParameterManager.getDirection()) {
            const direction = this.urlParameterManager.getDirection();
            let directionState = {};
            if (direction === null || direction === void 0 ? void 0 : direction.from) directionState = {
                ...directionState,
                origin: direction.from
            };
            if (direction === null || direction === void 0 ? void 0 : direction.to) directionState = {
                ...directionState,
                destination: direction.to
            };
            this.directionsComponent.setState(directionState, true, ()=>{
                this.directionsComponent.emit((0, $d79cb7225149ae37$export$a7fa205fa3fad685).DESTINATION_CHANGED);
                this.setDirectionsView();
            });
        } else this.setListView();
    }
    setUserPosition(position) {
        if (!position && this.userLocationMarker) {
            this.userLocationMarker.setMap(null);
            return;
        }
        if (position) {
            if (!this.userLocationMarker) this.userLocationMarker = new woosmap.map.Marker({
                position: position,
                icon: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().map.userLocationIconOptions
            });
            else this.userLocationMarker.setPosition(position);
            this.userLocationMarker.setMap(this.mapComponent.map);
        }
    }
    setDetailsView() {
        this.$target.className = "details_view";
        this.$sidebarContentContainer.scrollTo(0, 0);
    }
    setListView() {
        this.$target.className = "list_view";
        this.$sidebarContentContainer.scrollTo(0, 0);
    }
    setDirectionsView() {
        this.$target.className = "directions_view";
    }
    setRoadbookView() {
        this.$target.className = "roadbook_view";
    }
    styleOnScroll() {
        var _this_$sidebarContentContainer;
        (_this_$sidebarContentContainer = this.$sidebarContentContainer) === null || _this_$sidebarContentContainer === void 0 ? void 0 : _this_$sidebarContentContainer.addEventListener("scroll", ()=>{
            const scroll = this.$sidebarContentContainer.scrollTop;
            if (scroll > 0) this.$sidebarContentContainer.classList.add("active");
            else this.$sidebarContentContainer.classList.remove("active");
        });
    }
    managePadding() {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        //On Mobile, padding from bottom to 56% of Store Locator height
        (0, $d0a7dfeff55f6162$export$44487a86467333c3)().map.mapPaddings.mobile.bottom = Math.round(document.getElementById((0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.mapContainerID).clientHeight * 0.56);
        if (width >= (0, $d0a7dfeff55f6162$export$44487a86467333c3)().map.mobileBreakPoint) this.setState({
            padding: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().map.mapPaddings.full
        }, true, ()=>{
            this.emit("padding_changed");
        });
        else this.setState({
            padding: (0, $d0a7dfeff55f6162$export$44487a86467333c3)().map.mapPaddings.mobile
        }, true, ()=>{
            this.emit("padding_changed");
        });
    }
    getHTMLSkeleton() {
        return `
        <div id="${(0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.mapContainerID}"></div>
        <div id="${(0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.sidebarContainerID}">
           <div id="${(0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.searchContainerID}">
              <div id="${(0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.searchWrapperID}"></div>
           </div>
           <div id="${(0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.sidebarContentContainerID}">
               <div id="${(0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.filterPanelContainerID}"></div>
               <div id="${(0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.listStoresContainerID}"></div>
               <div id="${(0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.detailsStoreContainerID}"></div>
           </div>
        <div id="${(0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.directionsContainerID}"></div>   
        <div id="${(0, $d0a7dfeff55f6162$export$44487a86467333c3)().selectors.roadbookContainerID}"></div>
        </div>`;
    }
}


window.woosmapLocator = (0, $207b26abb5e33c5a$export$2e2bcd8739ae039);

})();
//# sourceMappingURL=index.e7cd7596.js.map
